import {
  Users, Briefcase, CalendarDays, UsersRound, MapPin, Sparkles, Heart, Eye,
  Zap, Mic, HelpCircle, Gamepad2, ShieldCheck, Music, Coffee, BusFront,
  Handshake, UserRound, Megaphone, Search, Star, MessageCircle,
} from 'lucide-react';

const SHOWCASE_MEDIA = {
  pocetna: { img: '/assets/screen-home.webp' },
  istrazi: { img: '/assets/screen-discover.webp' },
  biznisi: { img: '/assets/screen-discover.webp', zoom: 'phone-zoom-list' },
  iskra: { img: '/assets/screen-iskra.webp' },
  'mini-igre': { img: '/assets/screen-iskra.webp', zoom: 'phone-zoom-alati' },
};

const showcaseTabs = (labels, captions) =>
  ['pocetna', 'istrazi', 'biznisi', 'iskra', 'mini-igre'].map((id, i) => ({
    id,
    label: labels[i],
    caption: captions[i],
    ...SHOWCASE_MEDIA[id],
  }));

const bs = {
  nav: {
    links: [
      { label: 'Početna', href: '#pocetna', testid: 'nav-link-pocetna' },
      { label: 'Kako radi', href: '#kako-radi', testid: 'nav-link-kako-radi' },
      { label: 'Funkcije', href: '#funkcije', testid: 'nav-link-funkcije' },
      { label: 'KRUG ISKRA', href: '#iskra', testid: 'nav-link-iskra' },
      { label: 'Za biznise', href: '#za-biznise', testid: 'nav-link-za-biznise' },
      { label: 'FAQ', href: '#faq', testid: 'nav-link-faq' },
    ],
    cta: 'Pridruži se među prvima',
    soonTitle: 'Uskoro dostupno',
  },
  hero: {
    eyebrow: 'KRUG za dijasporu',
    titleA: 'Pronađi',
    titleB: 'svoj krug.',
    sub: 'Ljudi, biznisi, događaji i nova poznanstva u dijaspori — sve na jednom mjestu.',
    supporting: 'KRUG povezuje dijasporu kroz zajednicu, lokalne biznise, događaje i smislena povezivanja.',
    ctaPrimary: 'Pridruži se među prvima',
    ctaSecondary: 'Pogledaj aplikaciju',
    storeNote: 'Sada dostupno za iOS · Android uskoro',
    storeSoon: 'Uskoro dostupno',
    storeLive: 'Preuzmi sada',
    countdownTitle: 'Android verzija stiže za',
    cDays: 'dana',
    cHours: 'sat',
    cMins: 'min',
    cSecs: 'sek',
    launchedTitle: 'KRUG je stigao!',
    launchedSub: 'Dostupan za iOS i Android — preuzmi aplikaciju i pronađi svoj krug.',
  },
  marquee: ['Ljudi', 'Biznisi', 'Događaji', 'Zajednice', 'KRUG ISKRA', 'Pronađi svoj krug'],
  valueStrip: [
    { icon: MapPin, label: 'Ljudi u tvojoj blizini' },
    { icon: Briefcase, label: 'Biznisi iz dijaspore' },
    { icon: CalendarDays, label: 'Događaji i zajednice' },
    { icon: Sparkles, label: 'KRUG ISKRA' },
  ],
  whatIs: {
    eyebrow: 'Šta je KRUG',
    title: 'Sve što dijaspora treba — u jednom krugu.',
    copy: 'Danas su ljudi, biznisi, događaji i zajednice rasuti kroz desetine Facebook grupa, stranica i aplikacija. KRUG ih okuplja na jednom mjestu.',
  },
  cards: [
    { icon: Users, title: 'Ljudi', copy: 'Pronađi ljude iz svog kraja, grada ili okoline i poveži se kroz zajedničke interese.', preview: ['Sarajevo → München', 'Zajednički interesi', 'Privatne poruke'] },
    { icon: Briefcase, title: 'Biznisi', copy: 'Otkrij restorane, firme, usluge i poduzetnike iz dijaspore.', preview: ['Restorani · Essen', 'Verifikovani profili', 'Ocjene zajednice'] },
    { icon: CalendarDays, title: 'Događaji', copy: 'Pronađi koncerte, druženja, putovanja i lokalna okupljanja.', preview: ['Koncerti i druženja', 'Putovanja', 'Lokalna dešavanja'] },
    { icon: UsersRound, title: 'Zajednice', copy: 'Pridruži se grupama i upoznaj ljude koji dijele tvoje interese.', preview: ['Grupe po interesima', 'Lokalne zajednice', 'Aktivni članovi'] },
  ],
  showcase: {
    eyebrow: 'Pogled iznutra',
    title: 'KRUG iznutra.',
    copy: 'Jednostavan za korištenje. Napravljen za stvarni život u dijaspori.',
    tabsAria: 'Ekrani aplikacije',
    tabs: showcaseTabs(
      ['Početna', 'Istraži', 'Biznisi', 'KRUG ISKRA', 'Mini-igre'],
      [
        'Tvoj dan u dijaspori — događaji, biznisi i krug u blizini.',
        'Pretraga ljudi, biznisa i dešavanja u dijaspori.',
        'Restorani, firme i usluge — sa ocjenama i istaknutim profilima.',
        'Današnji krug — do 5 pažljivo izabranih ljudi svaki dan.',
        'Mini-igre, Voice intro, Kako bi ti? — upoznavanje kroz igru.',
      ],
    ),
  },
  people: {
    eyebrow: 'Ljudi',
    title: 'Pronađi svoje ljude.',
    copy: 'Novi grad ne mora značiti novi početak bez poznatih ljudi. KRUG ti pomaže pronaći ljude iz tvog kraja, sličnih interesa i zajednice u kojoj živiš.',
    highlights: ['Pretraga po gradu i okolini', 'Zajednički interesi', 'Lokalne zajednice', 'Privatne poruke', 'Kontrola privatnosti'],
    cta: 'Uđi u svoj krug',
  },
  business: {
    eyebrow: 'Za biznise',
    title: 'Naši biznisi. Lakše za pronaći.',
    copy: 'Od restorana i građevinskih firmi do IT-a, transporta, zdravstvenih i administrativnih usluga — KRUG daje dijasporskim biznisima mjesto gdje ih njihova zajednica može pronaći.',
    features: [
      { icon: Search, label: 'Pretraga po gradu' },
      { icon: Briefcase, label: 'Kategorije' },
      { icon: Star, label: 'Ocjene' },
      { icon: Sparkles, label: 'Istaknuti biznisi' },
      { icon: ShieldCheck, label: 'Verifikovani profili' },
      { icon: MessageCircle, label: 'Direktan kontakt' },
      { icon: Eye, label: 'Lokalna vidljivost' },
    ],
    boxTitle: 'Imaš biznis? KRUG je i za tebe.',
    boxCta: 'Saznaj više',
  },
  events: {
    eyebrow: 'Događaji',
    title: 'Šta se dešava u tvom gradu?',
    copy: 'Koncerti, druženja, putovanja, poslovni eventi, porodična okupljanja i lokalna dešavanja — bez traženja kroz desetine grupa.',
    cards: [
      { icon: Music, tag: 'Koncerti', copy: 'Nastupi, žurke i muzičke večeri u tvom gradu.' },
      { icon: Coffee, tag: 'Druženja', copy: 'Kafe, iftari, sevdah večeri i spontana okupljanja.' },
      { icon: BusFront, tag: 'Putovanja', copy: 'Zajednička putovanja, izleti i vikend ture.' },
      { icon: Handshake, tag: 'Poslovno & porodica', copy: 'Networking eventi, sajamski susreti i porodična okupljanja.' },
    ],
    highlights: ['Događaji u blizini', 'Lokalne preporuke', 'Organizatori', 'Prijave', 'Podsjetnici', 'Community eventi'],
  },
  iskra: {
    eyebrow: 'Poseban modul unutar KRUGA',
    sub: 'Ne biraj sliku. Prepoznaj osobu.',
    copy: 'KRUG ISKRA je napravljen za one koji žele smislenije upoznavanje. Manje beskrajnog swipeanja, više stvarne interakcije kroz interese, vrijednosti i način života.',
    features: [
      { icon: Zap, title: 'Današnji krug', copy: 'Do 5 pažljivo odabranih preporuka dnevno.' },
      { icon: Mic, title: 'Voice intro', copy: 'Upoznaj nečiji glas i energiju prije prvog razgovora.' },
      { icon: HelpCircle, title: 'Kako bi ti?', copy: 'Pitanja i stvarne životne situacije koje otkrivaju koliko se poklapate.' },
      { icon: Gamepad2, title: 'Mini-igre', copy: 'Upoznajte se kroz kratke zajedničke izazove.' },
      { icon: Users, title: 'Krug sobe', copy: 'Manje grupne sesije za prirodnije upoznavanje.' },
      { icon: ShieldCheck, title: 'Safety', copy: 'Kontrola privatnosti, prijava i sigurnosne funkcije.' },
    ],
    statementA: 'Manje matcheva. ',
    statementB: 'Više stvarnih susreta.',
    cta: 'Otkrij KRUG ISKRA',
  },
  miniGames: {
    eyebrow: 'Mini-igre',
    title: 'Povezivanje može biti zabavnije.',
    copy: 'Mini-igre unutar KRUG ISKRA omogućavaju ljudima da se upoznaju kroz izbore, prioritete i zajedničke situacije — bez neprijatnih prvih pitanja.',
    tags: ['Biramo zajedno', 'Naš vikend', 'Tri prioriteta', 'Ovo ili ono', 'Balkanska duša', 'Emoji priča'],
  },
  why: {
    eyebrow: 'Zašto KRUG',
    title: 'Zašto KRUG?',
    items: [
      { icon: MapPin, title: 'Blizina', copy: 'Pronađi ljude i događaje tamo gdje stvarno živiš.' },
      { icon: Heart, title: 'Zajednica', copy: 'Ostani povezan sa svojim ljudima i kad si daleko od kuće.' },
      { icon: Eye, title: 'Vidljivost', copy: 'Podrži biznise i ljude iz svoje zajednice.' },
      { icon: Sparkles, title: 'Nova poznanstva', copy: 'Od prijateljstva i poslovnih kontakata do nečeg više.' },
    ],
    noteA: 'KRUG tek počinje. ',
    noteB: 'Budi među prvima.',
  },
  who: {
    eyebrow: 'Kome je namijenjen',
    title: 'KRUG je tvoj — kako god da ga koristiš.',
    cards: [
      { icon: UserRound, title: 'Za ljude', copy: 'Nova poznanstva, lokalna zajednica i lakši život u dijaspori.' },
      { icon: Briefcase, title: 'Za biznise', copy: 'Vidljivost tamo gdje su tvoji kupci.' },
      { icon: Megaphone, title: 'Za organizatore', copy: 'Promoviši događaje direktno relevantnoj publici.' },
    ],
    linkLabel: 'Pridruži se listi',
  },
  waitlist: {
    eyebrow: 'Rani pristup',
    title: 'Budi među prvima u KRUG-u.',
    copy: 'KRUG uskoro stiže. Ostavi svoj email i javićemo ti kada aplikacija bude dostupna.',
    labels: { name: 'Ime', email: 'Email', city: 'Grad', country: 'Država', optional: '(opcionalno)' },
    placeholders: { name: 'Tvoje ime', email: 'ime@email.com', city: 'npr. München', country: 'npr. Njemačka' },
    errors: { name: 'Unesi svoje ime.', email: 'Unesi validnu email adresu.' },
    newsletter: 'Želim primati novosti o KRUG aplikaciji.',
    submit: 'Pridruži se listi',
    gdprBefore: 'Slanjem obrasca pristaješ da KRUG (izdavač: Sandy Smajic Consulting) tvoje podatke koristi isključivo za obavijest o lansiranju aplikacije i — samo ako si označio/la — za novosti o KRUG-u. Podaci se ne dijele s trećim stranama i možeš zatražiti brisanje u svakom trenutku. Više na stranici ',
    gdprLink: 'Privatnost',
    gdprAfter: '.',
    successTitle: 'Dobrodošao/la u KRUG.',
    successMsg: 'Javljamo ti kada krenemo.',
    duplicateMsg: 'Ovaj email je već na listi — javljamo ti kada krenemo.',
    failToast: 'Nešto je pošlo po zlu. Pokušaj ponovo za par trenutaka.',
  },
  store: {
    titleA: 'Tvoj krug je bliže ',
    titleB: 'nego što misliš.',
    sub: 'Sada dostupno za iOS — Android stiže uskoro.',
    soon: 'Uskoro',
    soonTitle: 'Link će biti dodan pri lansiranju',
    live: 'Dostupno sada',
  },
  faq: {
    eyebrow: 'Česta pitanja',
    title: 'Pitanja? Odgovori.',
    items: [
      { q: 'Šta je KRUG?', a: 'KRUG je mobilna aplikacija za dijasporu koja povezuje ljude, biznise, događaje i zajednice na jednom mjestu.' },
      { q: 'Kome je namijenjen?', a: 'Prvenstveno ljudima iz Bosne i Hercegovine i Balkana koji žive u dijaspori, ali platforma je otvorena za širu zajednicu.' },
      { q: 'Gdje će KRUG biti dostupan?', a: 'KRUG je fokusiran na Njemačku, Austriju i Švicarsku, uz planirano širenje na ostatak Evrope.' },
      { q: 'Šta je KRUG ISKRA?', a: 'KRUG ISKRA je poseban modul za smislenije upoznavanje i povezivanje bez beskrajnog swipeanja.' },
      { q: 'Da li je KRUG dating aplikacija?', a: 'Ne. KRUG je šira društvena i lokalna platforma. KRUG ISKRA je samo jedan opcionalni modul unutar aplikacije.' },
      { q: 'Da li mogu registrovati biznis?', a: 'Da. KRUG je dizajniran i za biznise i usluge iz dijaspore.' },
      { q: 'Da li će KRUG biti besplatan?', a: 'Osnovne funkcije trebaju biti dostupne besplatno. Premium funkcije mogu biti uvedene kasnije.' },
      { q: 'Kada aplikacija izlazi?', a: 'KRUG je trenutno u završnoj fazi pripreme za javno lansiranje. Prijavi se na listu i obavijestićemo te kada bude dostupan.' },
    ],
  },
  footer: {
    tagline: 'KRUG — digitalna zajednica za dijasporu.',
    slogan: 'Pronađi svoj krug.',
    pagesTitle: 'Stranice',
    infoTitle: 'Info',
    nav: [
      { label: 'Početna', href: '/#pocetna' },
      { label: 'Kako radi', href: '/#kako-radi' },
      { label: 'KRUG ISKRA', href: '/#iskra' },
      { label: 'Biznisi', href: '/#za-biznise' },
      { label: 'Događaji', href: '/#dogadjaji' },
      { label: 'FAQ', href: '/#faq' },
    ],
    legal: [
      { label: 'Kontakt', href: '/contact' },
      { label: 'Podrška', href: '/support' },
      { label: 'Privatnost', href: '/privacy' },
      { label: 'Uslovi korištenja', href: '/terms' },
      { label: 'Community Guidelines', href: '/community-guidelines' },
    ],
    copyright: '© 2026 KRUG. Sva prava zadržana.',
    publisherLabel: 'Izdavač',
    cookie: {
      text: 'Koristimo kolačiće za tehnički rad stranice i anonimiziranu analitiku posjeta. Prihvatanjem pomažeš da KRUG bude bolji.',
      accept: 'Prihvati',
      decline: 'Samo neophodni',
      more: 'Više informacija',
      settings: 'Postavke kolačića',
    },
    support: {
      title: 'Podrška',
      sub: 'Tu smo da pomognemo — javi nam se i odgovaramo po pravilu u roku od 2 radna dana.',
      emailTitle: 'Email podrške',
      formTitle: 'Kontakt forma',
      labels: { name: 'Ime', email: 'Email', topic: 'Tema', message: 'Poruka' },
      topics: ['Opće pitanje', 'Problem s prijavom', 'Biznis profil', 'KRUG ISKRA', 'Podaci i privatnost', 'Ostalo'],
      placeholderMessage: 'Kako ti možemo pomoći?',
      submit: 'Pošalji poruku',
      successTitle: 'Poruka poslana!',
      successMsg: 'Hvala na javljanju — odgovaramo ti na email u najkraćem roku.',
      failToast: 'Slanje nije uspjelo. Pokušaj ponovo ili piši direktno na info@krug-app.eu.',
      errors: { name: 'Unesi svoje ime.', email: 'Unesi validnu email adresu.', message: 'Poruka mora imati bar 10 znakova.' },
      helpTitle: 'Brza pomoć',
      help: [
        { t: 'Potvrdni email nije stigao', d: 'Provjeri spam/promo folder. Ako ga nema, prijavi se ponovo istom adresom ili nam piši.' },
        { t: 'Brisanje podataka', d: 'Za brisanje svojih podataka pošalji zahtjev na info@krug-app.eu — odgovaramo u zakonskom roku.' },
        { t: 'Biznis profili', d: 'Želiš registrirati biznis? Odaberi temu "Biznis profil" u formi i javit ćemo ti detalje prije lansiranja.' },
        { t: 'Česta pitanja', d: 'Odgovore na najčešća pitanja pogledaj u FAQ sekciji na početnoj stranici.', link: '/#faq', linkLabel: 'Otvori FAQ' },
      ],
    },
  },
  admin: {
    loginTitle: 'KRUG Admin',
    loginSub: 'Prijavi se za pregled prijava',
    email: 'Email',
    password: 'Lozinka',
    login: 'Prijava',
    loginError: 'Pogrešan email ili lozinka.',
    dashboard: 'Pregled prijava',
    total: 'Ukupno prijava',
    colName: 'Ime',
    colEmail: 'Email',
    colCity: 'Grad',
    colCountry: 'Država',
    colNewsletter: 'Novosti',
    colDate: 'Datum',
    exportCsv: 'Izvezi CSV',
    adminsTitle: 'Admini',
    addAdminTitle: 'Dodaj novog admina',
    addAdminBtn: 'Dodaj admina',
    onlySuper: 'Samo glavni admin (Smajic) može dodavati nove admine.',
    added: 'Admin uspješno dodan.',
    exists: 'Ovaj admin već postoji.',
    logout: 'Odjava',
    empty: 'Još nema prijava.',
    yes: 'Da',
    no: 'Ne',
    roleSuper: 'glavni admin',
    roleAdmin: 'admin',
    delete: 'Obriši',
    deleteConfirm: 'Obrisati prijavu za',
    deleted: 'Prijava obrisana.',
    deleteFail: 'Brisanje nije uspjelo.',
    statsTitle: 'Statistika prijava',
    perDay: 'Prijave po danima',
    perCountry: 'Raspodjela po državama',
    unknownCountry: 'Nepoznato',
    changePasswordTitle: 'Promijeni lozinku',
    currentPassword: 'Trenutna lozinka',
    newPassword: 'Nova lozinka',
    changePasswordBtn: 'Spasi lozinku',
    passwordChanged: 'Lozinka uspješno promijenjena.',
    wrongCurrent: 'Trenutna lozinka nije tačna.',
    remove: 'Ukloni',
    removeConfirm: 'Ukloniti admina',
    removed: 'Admin uklonjen.',
    removeFail: 'Uklanjanje nije uspjelo.',
    broadcastBtn: 'Pošalji lansirni email',
    broadcastAndroidBtn: 'Pošalji Android lansirni email',
    broadcastAndroidConfirm: 'Poslati Android lansirni email SVIMA na listi čekanja?',
    broadcastConfirm: 'Poslati lansirni email SVIMA na listi čekanja?',
    broadcastQueued: 'Lansirni email se šalje na',
    broadcastFail: 'Slanje nije pokrenuto.',
    supportTitle: 'Poruke podrške',
    supportEmpty: 'Nema poruka podrške.',
    statusNew: 'Nova',
    statusRead: 'Pročitana',
    statusResolved: 'Riješena',
    markRead: 'Pročitano',
    markResolved: 'Riješeno',
    replyBtn: 'Odgovori',
    replyPlaceholder: 'Napiši odgovor korisniku...',
    replySend: 'Pošalji odgovor',
    replySent: 'Odgovor poslan korisniku.',
    replyFail: 'Slanje odgovora nije uspjelo.',
    filterAll: 'Sve',
    analyticsTitle: 'Statistika posjeta',
    totalViews: 'Pregledi stranice',
    totalClicks: 'Klikovi',
    uniqueVisitors: 'Jedinstveni posjetioci',
    activeNow: 'Aktivno sada',
    viewsToday: 'Danas',
    viewsPerDay: 'Pregledi (14 dana)',
    topPages: 'Najposjećenije stranice',
    topClicks: 'Najčešći klikovi',
    analyticsEmpty: 'Još nema podataka — statistika se prikuplja nakon saglasnosti za kolačiće.',
    tickets: {
      tab: 'Tiketi',
      overviewTab: 'Pregled',
      title: 'Tiketi podrške iz aplikacije',
      all: 'Svi',
      open: 'Otvoreni',
      answered: 'Odgovoreni',
      closed: 'Zatvoreni',
      refresh: 'Osvježi',
      loading: 'Učitavanje tiketa...',
      empty: 'Nema tiketa za odabrani filter.',
      unavailable: 'Servis podrške trenutno nije dostupan.',
      retry: 'Pokušaj ponovo',
      newLabel: 'Novo',
      back: 'Nazad na tikete',
      statusOpen: 'Otvoren',
      statusAnswered: 'Odgovoreno',
      statusClosed: 'Zatvoren',
      replyPlaceholder: 'Napiši odgovor korisniku...',
      replySend: 'Pošalji odgovor',
      replySent: 'Odgovor je poslan korisniku.',
      replyFail: 'Slanje odgovora nije uspjelo.',
      close: 'Zatvori tiket',
      reopen: 'Ponovo otvori tiket',
      statusChanged: 'Status tiketa je promijenjen.',
      statusFail: 'Promjena statusa nije uspjela.',
      support: 'KRUG podrška',
    },
    app: {
      tabs: { overview: 'Pregled', users: 'Korisnici', verifications: 'Verifikacije', reports: 'Prijave', finance: 'Finansije', tickets: 'Tiketi', audit: 'Audit', web: 'Web' },
      common: { refresh: 'Osvježi', loading: 'Učitavanje...', unavailable: 'Servis aplikacije trenutno nije dostupan.', retry: 'Pokušaj ponovo', empty: 'Nema podataka.' },
      stats: { title: 'Statistika aplikacije', general: 'Opće', exportCsv: 'Preuzmi CSV', days: 'dana' },
      users: {
        title: 'Korisnici aplikacije',
        searchPlaceholder: 'Pretraga po imenu ili emailu...',
        search: 'Traži',
        colUser: 'Korisnik',
        colRole: 'Uloga',
        colStatus: 'Status',
        colVerified: 'Verifikovan',
        colDate: 'Registrovan',
        actions: 'Akcije',
        banned: 'Blokiran',
        active: 'Aktivan',
        ban: 'Blokiraj',
        unban: 'Odblokiraj',
        banReason: 'Razlog blokade...',
        banConfirm: 'Blokirati korisnika',
        unbanConfirm: 'Odblokirati korisnika',
        roleSet: 'Postavi ulogu',
        roleConfirm: 'Promijeniti ulogu za',
        roleRegular: 'Korisnik',
        roleModerator: 'Moderator',
        roleSuper: 'Super admin',
        actionDone: 'Akcija uspješno izvršena.',
        actionFail: 'Akcija nije uspjela.',
        empty: 'Nema korisnika za prikaz.',
      },
      verifications: {
        title: 'Zahtjevi za verifikaciju',
        approve: 'Odobri',
        reject: 'Odbij',
        notePlaceholder: 'Napomena (obavezna kod odbijanja)...',
        noteRequired: 'Napomena je obavezna kod odbijanja.',
        approveConfirm: 'Odobriti verifikaciju za',
        rejectConfirm: 'Odbiti verifikaciju za',
        done: 'Zahtjev obrađen.',
        fail: 'Akcija nije uspjela.',
        empty: 'Nema zahtjeva na čekanju.',
      },
      reports: {
        title: 'Moderacija',
        reportsTitle: 'Prijave sadržaja',
        appealsTitle: 'Žalbe korisnika',
        actDismiss: 'Odbaci prijavu',
        actWarn: 'Upozori korisnika',
        actRemove: 'Ukloni sadržaj',
        actBan: 'Blokiraj korisnika',
        notePlaceholder: 'Napomena uz akciju...',
        submit: 'Izvrši akciju',
        submitConfirm: 'Izvršiti odabranu akciju?',
        accept: 'Prihvati žalbu',
        rejectAppeal: 'Odbij žalbu',
        acceptConfirm: 'Prihvatiti žalbu?',
        rejectConfirm: 'Odbiti žalbu?',
        done: 'Akcija uspješno izvršena.',
        fail: 'Akcija nije uspjela.',
        emptyReports: 'Nema prijava na čekanju.',
        emptyAppeals: 'Nema žalbi na čekanju.',
      },
      finance: { title: 'Finansije', empty: 'Nema zabilježenih kupovina.' },
      audit: { title: 'Audit log', empty: 'Nema zabilježenih admin akcija.' },
      fields: {
        users: 'Korisnici', content: 'Sadržaj', finance: 'Finansije', iskra: 'KRUG ISKRA',
        total: 'Ukupno', new_24h: 'Novo (24h)', new_7d: 'Novo (7 dana)', new_30d: 'Novo (30 dana)',
        verified: 'Verifikovani', banned: 'Blokirani',
        posts: 'Objave', events: 'Događaji', businesses: 'Biznisi', listings: 'Oglasi',
        display_name: 'Ime', name: 'Ime', user_name: 'Korisnik', user_email: 'Email', email: 'Email',
        role: 'Uloga', status: 'Status', created_at: 'Datum', updated_at: 'Ažurirano', last_message_at: 'Zadnja poruka',
        amount: 'Iznos', currency: 'Valuta', type: 'Tip', kind: 'Vrsta', credits: 'Krediti',
        action: 'Akcija', admin: 'Admin', admin_email: 'Admin', target: 'Meta', note: 'Napomena', reason: 'Razlog',
        subject: 'Naslov', message: 'Poruka', count: 'Broj', revenue: 'Prihod', purchases: 'Kupovine',
        tickets: 'Ulaznice', category: 'Kategorija', category_label: 'Kategorija', description: 'Opis',
        details: 'Detalji', source: 'Izvor', ban: 'Blokada', warn: 'Upozorenje', dismiss: 'Odbačeno',
        remove_content: 'Uklonjen sadržaj', accept: 'Prihvaćeno', reject: 'Odbijeno', approve: 'Odobreno',
      },
    },
  },
  legal: {
    back: 'Nazad na početnu',
    draft: 'Zadnja izmjena: august 2026',
    pdf: 'Preuzmi kao PDF',
    pages: {
      privacy: {
        title: 'Izjava o privatnosti',
        sections: [
          { h: '1. Odgovorni za obradu podataka', lines: ['Sandy Smajic, BSc IT', 'Sandy Smajic Consulting', 'Maxstr. 3, 45127 Essen, Njemačka', 'Telefon: +49 176 70035262', 'Email (KRUG aplikacija i pitanja o privatnosti): info@krug-app.eu', 'Email (Consulting): info@sandysmajic.com'] },
          { h: '2. Obim ove izjave', p: 'Ova izjava o privatnosti važi za mobilnu aplikaciju KRUG (uključujući modul KRUG ISKRA) i web stranicu krug-app.eu. Objašnjava koje lične podatke prikupljamo, u koje svrhe, na kojem pravnom osnovu, koliko dugo ih čuvamo i koja prava imate prema Općoj uredbi o zaštiti podataka (GDPR).' },
          { h: '3. Podaci o nalogu i registraciji', p: 'Prilikom registracije obrađujemo podatke potrebne za otvaranje i upravljanje nalogom: prikazano ime, email adresu, lozinku (koja se pohranjuje isključivo u sigurnosno heširanom obliku), datum registracije i status verifikacije naloga. Pravni osnov je izvršenje ugovora (čl. 6 st. 1 t. b GDPR).' },
          { h: '4. Podaci profila', p: 'Podatke koje sami unesete u profil (npr. ime, grad, država, jezici, interesi, opis) obrađujemo kako bismo prikazali vaš profil i omogućili funkcije povezivanja u zajednici (čl. 6 st. 1 t. b GDPR). Profilni podaci vidljivi su drugim korisnicima onoliko koliko to funkcije aplikacije zahtijevaju — unosite samo ono što želite podijeliti.' },
          { h: '5. Fotografije i učitani mediji', p: 'Fotografije i drugi mediji koje učitate (profilne fotografije, slike objava, događaja ili biznis profila) pohranjuju se na našim serverima i prikazuju u aplikaciji u skladu sa svrhom funkcije. Medije možete ukloniti brisanjem pojedinog sadržaja ili cijelog naloga.' },
          { h: '6. Podaci o lokaciji', p: 'Ako u postavkama uređaja odobrite pristup lokaciji, koristimo je za prikaz ljudi, događaja i biznisa u vašoj blizini. Pristup lokaciji je dobrovoljan i možete ga u svakom trenutku isključiti u postavkama uređaja; aplikacija tada radi bez funkcija zasnovanih na blizini. Pravni osnov: vaša saglasnost (čl. 6 st. 1 t. a GDPR).' },
          { h: '7. Poruke i sadržaj korisnika', p: 'Poruke, komentare, objave i drugi sadržaj koji kreirate obrađujemo i prikazujemo kako bi komunikacija i zajednica funkcionisali (čl. 6 st. 1 t. b GDPR). Sadržaj poruka pregledavamo samo u slučaju prijave kršenja pravila, radi moderacije i sigurnosti korisnika (čl. 6 st. 1 t. f GDPR — legitimni interes).' },
          { h: '8. Voice Intro i audio snimci', p: 'Ako koristite funkciju Voice Intro, audio snimak koji napravite pohranjuje se i reproducira u okviru vašeg profila dok ga sami ne uklonite. Snimak je sadržaj koji dobrovoljno objavljujete; pravni osnov je izvršenje ugovora i vaša saglasnost (čl. 6 st. 1 t. a i b GDPR).' },
          { h: '9. KRUG ISKRA — profil i preferencije', p: 'Modul KRUG ISKRA namijenjen je upoznavanju i dostupan je isključivo punoljetnim osobama (18+). Podaci koje unesete u ISKRA profil — uključujući preferencije za upoznavanje — mogu otkrivati posebne kategorije ličnih podataka (npr. seksualnu orijentaciju). Takve podatke obrađujemo isključivo na osnovu vaše izričite saglasnosti (čl. 9 st. 2 t. a GDPR) i samo u svrhu prikaza i povezivanja unutar modula. Saglasnost možete povući u svakom trenutku brisanjem ISKRA profila, bez negativnih posljedica za ostatak aplikacije.' },
          { h: '10. Događaji i interakcije u zajednici', p: 'Prilikom kreiranja događaja, potvrde dolaska, učlanjenja u grupe i interakcija sa sadržajem obrađujemo te podatke radi prikaza i organizacije zajedničkih aktivnosti (čl. 6 st. 1 t. b GDPR).' },
          { h: '11. Biznis profili i oglasi', p: 'Podaci o biznisima i oglasima (naziv, kategorija, kontakt, lokacija, opis, fotografije) objavljuju se javno u aplikaciji. Ako registrujete biznis, obrađujemo i vaše kontakt podatke kao vlasnika profila radi verifikacije i upravljanja profilom (čl. 6 st. 1 t. b GDPR).' },
          { h: '12. Tehnički podaci i podaci o uređaju', p: 'Radi stabilnosti, sigurnosti i otklanjanja grešaka obrađujemo tehničke podatke poput tipa uređaja, operativnog sistema, verzije aplikacije, IP adrese i zapisa o greškama (čl. 6 st. 1 t. f GDPR — legitimni interes u sigurnom i stabilnom radu servisa).' },
          { h: '13. Tokeni za push obavještenja', p: 'Ako dozvolite push obavještenja, pohranjujemo tehnički token vašeg uređaja kako bismo vam mogli slati obavještenja (npr. o novim porukama ili odgovorima podrške). Obavještenja možete u svakom trenutku isključiti u postavkama uređaja (čl. 6 st. 1 t. a i b GDPR).' },
          { h: '14. Analitika i kolačići', p: 'Na web stranici koristimo vlastitu, anonimiziranu statistiku posjeta, i to isključivo uz vašu saglasnost preko bannera za kolačiće (čl. 6 st. 1 t. a GDPR); saglasnost možete povući u postavkama kolačića u podnožju stranice. Ne koristimo kolačiće za oglašavanje trećih strana, ne pratimo vas za reklamne svrhe i ne prodajemo vaše podatke.' },
          { h: '15. Kupovine u aplikaciji i pretplate', p: 'Kupovine kredita, ulaznica i pretplata odvijaju se preko trgovina aplikacija. Apple (App Store) i Google (Google Play) procesiraju plaćanje kao samostalni odgovorni subjekti, u okviru vlastitih uslova i izjava o privatnosti; mi dobivamo samo potvrdu o kupovini (npr. vrsta i vrijeme), bez ikakvih podataka o vašem platnom instrumentu. Pravni osnov: izvršenje ugovora (čl. 6 st. 1 t. b GDPR).' },
          { h: '16. Pružaoci usluga i primatelji podataka', p: 'Za tehnički rad koristimo pažljivo odabrane pružaoce usluga: hosting i backend infrastrukturu (Emergent platforma) te slanje emailova s web stranice (Resend). Pružaoci obrađuju podatke isključivo po ugovoru o obradi i našem nalogu. Vaše podatke ne prodajemo i ne dijelimo ih s trećim stranama u marketinške svrhe.' },
          { h: '17. Prenos podataka u treće zemlje', p: 'Ako neki pružaoc usluga obrađuje podatke izvan Evropske unije, to se odvija samo uz garancije propisane GDPR-om (npr. standardne ugovorne klauzule, čl. 46 GDPR).' },
          { h: '18. Rokovi čuvanja podataka', p: 'Podatke naloga čuvamo dok je nalog aktivan. Nakon brisanja naloga lične podatke brišemo ili anonimiziramo, osim onih koje moramo zadržati radi zakonskih obaveza (npr. računovodstvene obaveze za kupovine — do 10 godina prema njemačkim propisima). Tehničke serverske zapise čuvamo kratkotrajno. Podatke s liste čekanja čuvamo do lansiranja aplikacije i razumnog perioda nakon njega, odnosno do povlačenja saglasnosti.' },
          { h: '19. Brisanje naloga', p: 'Zahtjev za brisanje naloga možete poslati bilo kada na info@krug-app.eu — nalog i povezane lične podatke (profil, fotografije, snimci, poruke, ISKRA podaci) brišemo bez nepotrebnog odlaganja, osim podataka koje zakonski moramo zadržati.' },
          { h: '20. Vaša prava', lines: ['Uvid u podatke koje čuvamo o vama (čl. 15 GDPR)', 'Ispravka netačnih podataka (čl. 16 GDPR)', 'Brisanje podataka (čl. 17 GDPR)', 'Ograničenje obrade (čl. 18 GDPR)', 'Prenosivost podataka (čl. 20 GDPR)', 'Prigovor na obradu (čl. 21 GDPR)', 'Povlačenje saglasnosti u svakom trenutku, bez posljedica (čl. 7 st. 3 GDPR)', 'Žalba nadležnom organu: Landesbeauftragte für Datenschutz und Informationsfreiheit NRW, Njemačka (čl. 77 GDPR)', 'Za ostvarivanje prava dovoljno je poslati email na info@krug-app.eu'] },
          { h: '21. Sigurnost podataka', p: 'Primjenjujemo odgovarajuće tehničke i organizacijske mjere: TLS enkripciju prijenosa, sigurnosno heširanje lozinki i ograničen pristup ovlaštenim osobama. Imajte na umu da ni jedan sistem ne može garantovati apsolutnu sigurnost.' },
          { h: '22. Maloljetnici', p: 'Aplikacija KRUG namijenjena je osobama starijim od 16 godina, a modul KRUG ISKRA isključivo punoljetnim osobama (18+). Svjesno ne prikupljamo podatke maloljetnika ispod dozvoljene granice; ako saznamo za takav nalog, brišemo ga.' },
          { h: '23. Blokiranje, prijave i moderacija', p: 'Radi sigurnosti zajednice obrađujemo prijave kršenja pravila, blokiranja i žalbe (uključujući sadržaj prijavljenog materijala i podatke o uključenim korisnicima), kao i administrativne mjere poput upozorenja ili suspenzije naloga (čl. 6 st. 1 t. f GDPR — legitimni interes u sigurnoj zajednici).' },
          { h: '24. Izmjene ove izjave', p: 'Ovu izjavu o privatnosti možemo povremeno aktualizirati, primjerice kada se funkcije aplikacije promijene. Važeća verzija je uvijek objavljena na ovoj stranici; o bitnim izmjenama obavještavamo korisnike u aplikaciji ili emailom.' },
          { h: '25. Kontakt za pitanja o privatnosti', p: 'Za sva pitanja, zahtjeve i prigovore vezane za zaštitu podataka pišite nam na info@krug-app.eu ili poštom na adresu navedenu u tački 1. Odgovaramo po pravilu u roku od 30 dana.' },
        ],
      },
      terms: {
        title: 'Uslovi korištenja',
        sections: [
          { h: '1. Obim važenja', p: 'Ovi uslovi korištenja važe za mobilnu aplikaciju KRUG (uključujući modul KRUG ISKRA) i web stranicu krug-app.eu. Korištenjem aplikacije ili stranice prihvatate ove uslove. Pravila ponašanja u zajednici dodatno su uređena Community Guidelines dokumentom.' },
          { h: '2. Izdavač', lines: ['Sandy Smajic Consulting', 'Sandy Smajic, BSc IT', 'Maxstr. 3, 45127 Essen, Njemačka', 'Telefon: +49 176 70035262', 'Email (KRUG aplikacija): info@krug-app.eu', 'Email (Consulting): info@sandysmajic.com'] },
          { h: '3. Opis usluge', p: 'KRUG je društvena i community platforma za dijasporu: povezivanje ljudi, otkrivanje biznisa i događaja, grupe i zajednice, minigame funkcije te modul KRUG ISKRA za upoznavanje. Web stranica služi predstavljanju aplikacije i prijavi na listu čekanja; prijava na listu čekanja je besplatna i neobavezujuća i ne stvara ugovorni odnos.' },
          { h: '4. Registracija i nalog', p: 'Aplikacija je namijenjena osobama starijim od 16 godina; modul KRUG ISKRA isključivo punoljetnim osobama (18+). Obavezujete se da su podaci pri registraciji tačni, da čuvate tajnost pristupnih podataka i da ne dijelite nalog s trećim osobama. Zabranjeno je otvaranje naloga za treće osobe bez njihove saglasnosti i lažno predstavljanje.' },
          { h: '5. Sadržaj korisnika', p: 'Zadržavate sva prava na sadržaj koji objavite (tekst, fotografije, audio, događaji, oglasi). Objavljivanjem nam dajete neisključivu, bez naknade, prostorno neograničenu dozvolu da taj sadržaj prikazujemo i tehnički obrađujemo u okviru aplikacije — dok sadržaj ili nalog ne uklonite. Odgovorni ste da vaš sadržaj ne krši zakone ni prava trećih osoba; zabranjeni sadržaji navedeni su u Community Guidelines. Zadržavamo pravo ukloniti sadržaj koji krši ove uslove.' },
          { h: '6. Dodatna pravila za KRUG ISKRA', p: 'ISKRA modul dostupan je samo punoljetnim osobama (18+). Obavezna je pristojna i dobrovoljna komunikacija; zabranjeni su eksplicitni sadržaj, pritisci, uznemiravanje, komercijalne usluge upoznavanja, prevara i iznuda. Kršenje ovih pravila dovodi do uklanjanja sadržaja, suspenzije ili trajnog brisanja naloga.' },
          { h: '7. Događaji i biznisi trećih osoba', p: 'Događaje, biznis profile i oglase kreiraju korisnici i treće osobe; za njihovu tačnost, kvalitet i legalnost odgovorni su njihovi organizatori i vlasnici. Učešće na događajima i poslovni odnosi s trećim osobama odvijaju se na vašu vlastitu odgovornost.' },
          { h: '8. Kupovine, krediti i pretplate', p: 'Kupovine kredita, ulaznica i pretplata naplaćuju se preko trgovina aplikacija (Apple App Store, odnosno Google Play) i važe njihovi uslovi plaćanja. Cijene i obim prikazuju se prije kupovine. Krediti su virtualna jedinica bez novčane vrijednosti: ne mogu se zamijeniti za novac, prenijeti na drugi nalog ni refundirati izvan pravila trgovina aplikacija. Pretplate se automatski obnavljaju dok ih ne otkažete u postavkama svog store naloga; otkazivanje i refundacije vrše se isključivo preko Apple, odnosno Google naloga. O promjeni cijena obavještavamo unaprijed u aplikaciji.' },
          { h: '9. Moderacija, suspenzija i raskid', p: 'Radi sigurnosti zajednice možemo upozoriti, privremeno suspendovati ili trajno ukloniti naloge koji krše ove uslove ili Community Guidelines, te po potrebi ukloniti sadržaj — uz mogućnost žalbe u aplikaciji. Vi možete u svakom trenutku raskinuti korištenje brisanjem naloga; time prestaju važeće pretplate prema pravilima store-a.' },
          { h: '10. Dostupnost i izmjene usluge', p: 'Trudimo se da usluga bude stalno dostupna, ali ne garantujemo neprekidan rad (npr. održavanje, tehnički kvarovi). Funkcije aplikacije možemo razvijati, mijenjati ili ukinuti; o bitnim izmjenama obavještavamo u aplikaciji.' },
          { h: '11. Odgovornost', p: 'Za štetu odgovaramo neograničeno u slučaju namjere i grube nepažnje, kao i za povredu života, tijela ili zdravlja. Kod lake nepažnje odgovaramo samo za povredu bitnih ugovornih obaveza, ograničeno na predvidivu štetu. Za sadržaj korisnika i trećih osoba ne odgovaramo. Odredbe Produkthaftungsgesetz i obavezna prava potrošača ostaju netaknute.' },
          { h: '12. Intelektualno vlasništvo', p: 'Naziv KRUG, logo, dizajn, tekstovi i programski kod aplikacije i stranice vlasništvo su izdavača i ne smiju se umnožavati ni koristiti bez pismene dozvole.' },
          { h: '13. Izmjene uslova', p: 'Ove uslove možemo izmijeniti uz obavijest u aplikaciji ili emailom; bitne izmjene najavljujemo razumno unaprijed. Nastavkom korištenja nakon stupanja izmjena na snagu prihvatate novu verziju; ako se ne slažete, možete obrisati nalog.' },
          { h: '14. Mjerodavno pravo i nadležnost', p: 'Pravo Savezne Republike Njemačke, uz isključenje kolizijskih normi; potrošačima ostaju obavezna zaštitna prava države prebivališta. Sjedište nadležnosti, koliko je zakonski dopušteno, je Essen.' },
          { h: '15. Kontakt', p: 'Za pitanja o ovim uslovima pišite na info@krug-app.eu — odgovaramo po pravilu u roku od 2 radna dana.' },
        ],
      },
      'community-guidelines': {
        title: 'Community Guidelines',
        sections: [
          { h: 'Svrha zajednice', p: 'KRUG okuplja ljude dijaspore, njihove biznise, događaje i zajednice. Ova pravila važe za sve korisnike aplikacije i štite sigurnost i kvalitet zajednice.' },
          { h: 'Poštovanje i ponašanje', p: 'Ne tolerišemo govor mržnje, diskriminaciju, uznemiravanje, prijetnje ni vrijeđanje — bez obzira na nacionalnost, vjeru, spol ili porijeklo. Komunicirajte onako kako biste željeli da se komunicira s vama.' },
          { h: 'Autentičnost', p: 'Profili, biznisi i događaji moraju biti stvarni i tačni. Lažno predstavljanje, prevara, spam i komercijalno oglašavanje bez dozvole dovode do uklanjanja sadržaja ili naloga.' },
          { h: 'Dodatna pravila za KRUG ISKRA', p: 'Modul ISKRA je namijenjen isključivo punoljetnim osobama (18+). Obavezna je pristojna komunikacija i poštovanje granica drugih korisnika; eksplicitni sadržaj i pritisci su zabranjeni.' },
          { h: 'Zabranjeni sadržaji', p: 'Zabranjeni su nezakoniti sadržaji, nasilje, eksplicitni materijal, podaci trećih osoba bez njihove saglasnosti, kao i sadržaji koji krše prava intelektualnog vlasništva.' },
          { h: 'Prijava kršenja', p: 'Sadržaj i korisnike koji krše pravila prijavite direktno u aplikaciji ili emailom na info@krug-app.eu. Svaku prijavu pregledamo povjerljivo.' },
          { h: 'Mjere i posljedice', p: 'Zavisno od težine kršenja primjenjujemo upozorenje, privremenu suspenziju ili trajno uklanjanje naloga, te po potrebi obavještavanje nadležnih organa.' },
          { h: 'Izmjene pravila', p: 'Pravila zajednice možemo povremeno aktualizirati; važeća verzija je objavljena na ovoj stranici.' },
        ],
      },
      contact: {
        title: 'Kontakt',
        sections: [
          { h: 'Izdavač (Impressum — § 5 DDG)', lines: ['Sandy Smajic Consulting', 'Sandy Smajic, BSc IT', 'Maxstr. 3', '45127 Essen', 'Savezna Republika Njemačka'] },
          { h: 'Kontakt', lines: ['Telefon: +49 176 70035262', 'Email (KRUG aplikacija): info@krug-app.eu', 'Email (Consulting): info@sandysmajic.com'] },
          { h: 'Odgovorno za sadržaj (§ 18 st. 2 MStV)', lines: ['Sandy Smajic', 'Adresa kao gore navedena'] },
          { h: 'Poslovni upiti', p: 'Za saradnju, biznis profile, događaje i medijske upite pišite nam emailom — odgovaramo po pravilu u roku od 2 radna dana.' },
        ],
      },
    },
  },
};

const de = {
  nav: {
    links: [
      { label: 'Start', href: '#pocetna', testid: 'nav-link-pocetna' },
      { label: 'So funktioniert’s', href: '#kako-radi', testid: 'nav-link-kako-radi' },
      { label: 'Funktionen', href: '#funkcije', testid: 'nav-link-funkcije' },
      { label: 'KRUG ISKRA', href: '#iskra', testid: 'nav-link-iskra' },
      { label: 'Für Unternehmen', href: '#za-biznise', testid: 'nav-link-za-biznise' },
      { label: 'FAQ', href: '#faq', testid: 'nav-link-faq' },
    ],
    cta: 'Sei früh dabei',
    soonTitle: 'Bald verfügbar',
  },
  hero: {
    eyebrow: 'KRUG für die Diaspora',
    titleA: 'Finde deinen',
    titleB: 'Kreis.',
    sub: 'Menschen, Unternehmen, Events und neue Bekanntschaften in der Diaspora — alles an einem Ort.',
    supporting: 'KRUG verbindet die Diaspora durch Community, lokale Unternehmen, Events und sinnvolle Verbindungen.',
    ctaPrimary: 'Sei früh dabei',
    ctaSecondary: 'App ansehen',
    storeNote: 'Jetzt für iOS · Android folgt in Kürze',
    storeSoon: 'Bald verfügbar',
    storeLive: 'Jetzt laden',
    countdownTitle: 'Android-Version kommt in',
    cDays: 'Tage',
    cHours: 'Std',
    cMins: 'Min',
    cSecs: 'Sek',
    launchedTitle: 'KRUG ist da!',
    launchedSub: 'Jetzt für iOS und Android — lade die App und finde deinen Kreis.',
  },
  marquee: ['Menschen', 'Unternehmen', 'Events', 'Communities', 'KRUG ISKRA', 'Finde deinen Kreis'],
  valueStrip: [
    { icon: MapPin, label: 'Menschen in deiner Nähe' },
    { icon: Briefcase, label: 'Unternehmen aus der Diaspora' },
    { icon: CalendarDays, label: 'Events & Communities' },
    { icon: Sparkles, label: 'KRUG ISKRA' },
  ],
  whatIs: {
    eyebrow: 'Was ist KRUG',
    title: 'Alles, was die Diaspora braucht — in einem Kreis.',
    copy: 'Heute sind Menschen, Unternehmen, Events und Communities über Dutzende Facebook-Gruppen, Seiten und Apps verstreut. KRUG bringt sie an einem Ort zusammen.',
  },
  cards: [
    { icon: Users, title: 'Menschen', copy: 'Finde Menschen aus deiner Heimat, Stadt oder Umgebung und vernetze dich über gemeinsame Interessen.', preview: ['Sarajevo → München', 'Gemeinsame Interessen', 'Private Nachrichten'] },
    { icon: Briefcase, title: 'Unternehmen', copy: 'Entdecke Restaurants, Firmen, Dienstleistungen und Unternehmer aus der Diaspora.', preview: ['Restaurants · Essen', 'Verifizierte Profile', 'Community-Bewertungen'] },
    { icon: CalendarDays, title: 'Events', copy: 'Finde Konzerte, Treffen, Reisen und lokale Veranstaltungen.', preview: ['Konzerte & Treffen', 'Reisen', 'Lokale Events'] },
    { icon: UsersRound, title: 'Communities', copy: 'Tritt Gruppen bei und lerne Menschen kennen, die deine Interessen teilen.', preview: ['Gruppen nach Interessen', 'Lokale Communities', 'Aktive Mitglieder'] },
  ],
  showcase: {
    eyebrow: 'Einblick',
    title: 'KRUG von innen.',
    copy: 'Einfach zu nutzen. Gemacht für das echte Leben in der Diaspora.',
    tabsAria: 'App-Bildschirme',
    tabs: showcaseTabs(
      ['Start', 'Entdecken', 'Unternehmen', 'KRUG ISKRA', 'Minispiele'],
      [
        'Dein Tag in der Diaspora — Events, Unternehmen und dein Kreis in der Nähe.',
        'Suche nach Menschen, Unternehmen und Events in der Diaspora.',
        'Restaurants, Firmen und Dienstleistungen — mit Bewertungen und hervorgehobenen Profilen.',
        'Der heutige Kreis — bis zu 5 sorgfältig ausgewählte Menschen jeden Tag.',
        'Minispiele, Voice Intro, Wie wär’s? — Kennenlernen durch Spiel.',
      ],
    ),
  },
  people: {
    eyebrow: 'Menschen',
    title: 'Finde deine Leute.',
    copy: 'Eine neue Stadt muss kein Neuanfang ohne bekannte Gesichter sein. KRUG hilft dir, Menschen aus deiner Heimat, mit ähnlichen Interessen und aus deiner Community zu finden.',
    highlights: ['Suche nach Stadt und Umgebung', 'Gemeinsame Interessen', 'Lokale Communities', 'Private Nachrichten', 'Kontrolle über deine Privatsphäre'],
    cta: 'Tritt deinem Kreis bei',
  },
  business: {
    eyebrow: 'Für Unternehmen',
    title: 'Unsere Unternehmen. Leichter zu finden.',
    copy: 'Von Restaurants und Bauunternehmen bis IT, Transport, Gesundheits- und Verwaltungsdienste — KRUG gibt Unternehmen der Diaspora einen Ort, an dem ihre Community sie finden kann.',
    features: [
      { icon: Search, label: 'Suche nach Stadt' },
      { icon: Briefcase, label: 'Kategorien' },
      { icon: Star, label: 'Bewertungen' },
      { icon: Sparkles, label: 'Hervorgehobene Unternehmen' },
      { icon: ShieldCheck, label: 'Verifizierte Profile' },
      { icon: MessageCircle, label: 'Direkter Kontakt' },
      { icon: Eye, label: 'Lokale Sichtbarkeit' },
    ],
    boxTitle: 'Du hast ein Unternehmen? KRUG ist auch für dich.',
    boxCta: 'Mehr erfahren',
  },
  events: {
    eyebrow: 'Events',
    title: 'Was ist los in deiner Stadt?',
    copy: 'Konzerte, Treffen, Reisen, Business-Events, Familienfeiern und lokale Veranstaltungen — ohne Suche durch Dutzende Gruppen.',
    cards: [
      { icon: Music, tag: 'Konzerte', copy: 'Auftritte, Partys und Musikabende in deiner Stadt.' },
      { icon: Coffee, tag: 'Treffen', copy: 'Kaffee, Iftare, Sevdah-Abende und spontane Treffen.' },
      { icon: BusFront, tag: 'Reisen', copy: 'Gemeinsame Reisen, Ausflüge und Wochenendtouren.' },
      { icon: Handshake, tag: 'Business & Familie', copy: 'Networking-Events, Messen und Familienfeiern.' },
    ],
    highlights: ['Events in der Nähe', 'Lokale Empfehlungen', 'Veranstalter', 'Anmeldungen', 'Erinnerungen', 'Community-Events'],
  },
  iskra: {
    eyebrow: 'Ein besonderes Modul in KRUG',
    sub: 'Wähle kein Bild. Erkenne die Person.',
    copy: 'KRUG ISKRA ist für alle, die sich sinnvollere Begegnungen wünschen. Weniger endloses Swipen, mehr echte Interaktion durch Interessen, Werte und Lebensstil.',
    features: [
      { icon: Zap, title: 'Heutiger Kreis', copy: 'Bis zu 5 sorgfältig ausgewählte Empfehlungen pro Tag.' },
      { icon: Mic, title: 'Voice Intro', copy: 'Lerne Stimme und Energie vor dem ersten Gespräch kennen.' },
      { icon: HelpCircle, title: 'Wie wär’s?', copy: 'Fragen und echte Lebenssituationen zeigen, wie gut ihr zusammenpasst.' },
      { icon: Gamepad2, title: 'Minispiele', copy: 'Lernt euch durch kurze gemeinsame Challenges kennen.' },
      { icon: Users, title: 'Kreis-Räume', copy: 'Kleine Gruppensessions für natürlicheres Kennenlernen.' },
      { icon: ShieldCheck, title: 'Safety', copy: 'Privatsphäre, Meldefunktion und Sicherheitsfunktionen.' },
    ],
    statementA: 'Weniger Matches. ',
    statementB: 'Mehr echte Begegnungen.',
    cta: 'Entdecke KRUG ISKRA',
  },
  miniGames: {
    eyebrow: 'Minispiele',
    title: 'Vernetzen kann mehr Spaß machen.',
    copy: 'Minispiele in KRUG ISKRA ermöglichen es, sich über Entscheidungen, Prioritäten und gemeinsame Situationen kennenzulernen — ohne peinliche erste Fragen.',
    tags: ['Wir wählen zusammen', 'Unser Wochenende', 'Drei Prioritäten', 'Dies oder Das', 'Balkan-Seele', 'Emoji-Story'],
  },
  why: {
    eyebrow: 'Warum KRUG',
    title: 'Warum KRUG?',
    items: [
      { icon: MapPin, title: 'Nähe', copy: 'Finde Menschen und Events dort, wo du wirklich lebst.' },
      { icon: Heart, title: 'Gemeinschaft', copy: 'Bleib mit deinen Leuten verbunden, auch weit weg von zu Hause.' },
      { icon: Eye, title: 'Sichtbarkeit', copy: 'Unterstütze Unternehmen und Menschen aus deiner Community.' },
      { icon: Sparkles, title: 'Neue Bekanntschaften', copy: 'Von Freundschaft und Geschäftskontakten bis zu etwas mehr.' },
    ],
    noteA: 'KRUG fängt gerade erst an. ',
    noteB: 'Sei von Anfang an dabei.',
  },
  who: {
    eyebrow: 'Für wen',
    title: 'KRUG gehört dir — egal, wie du es nutzt.',
    cards: [
      { icon: UserRound, title: 'Für Menschen', copy: 'Neue Bekanntschaften, lokale Community und ein leichteres Leben in der Diaspora.' },
      { icon: Briefcase, title: 'Für Unternehmen', copy: 'Sichtbarkeit dort, wo deine Kunden sind.' },
      { icon: Megaphone, title: 'Für Veranstalter', copy: 'Bewirb deine Events direkt beim relevanten Publikum.' },
    ],
    linkLabel: 'Zur Warteliste',
  },
  waitlist: {
    eyebrow: 'Früher Zugang',
    title: 'Sei unter den Ersten in KRUG.',
    copy: 'KRUG kommt bald. Hinterlasse deine E-Mail und wir melden uns, sobald die App verfügbar ist.',
    labels: { name: 'Name', email: 'E-Mail', city: 'Stadt', country: 'Land', optional: '(optional)' },
    placeholders: { name: 'Dein Name', email: 'name@email.com', city: 'z. B. München', country: 'z. B. Deutschland' },
    errors: { name: 'Bitte gib deinen Namen ein.', email: 'Bitte gib eine gültige E-Mail-Adresse ein.' },
    newsletter: 'Ich möchte Neuigkeiten zur KRUG App erhalten.',
    submit: 'Zur Liste anmelden',
    gdprBefore: 'Mit dem Absenden stimmst du zu, dass KRUG (Herausgeber: Sandy Smajic Consulting) deine Daten ausschließlich für die Benachrichtigung über den App-Launch und — nur falls angehakt — für Neuigkeiten zu KRUG verwendet. Daten werden nicht an Dritte weitergegeben; die Löschung ist jederzeit möglich. Mehr auf der Seite ',
    gdprLink: 'Datenschutz',
    gdprAfter: '.',
    successTitle: 'Willkommen in KRUG.',
    successMsg: 'Wir melden uns, sobald es losgeht.',
    duplicateMsg: 'Diese E-Mail ist bereits auf der Liste — wir melden uns, sobald es losgeht.',
    failToast: 'Etwas ist schiefgelaufen. Bitte versuche es in ein paar Momenten erneut.',
  },
  store: {
    titleA: 'Dein Kreis ist näher ',
    titleB: 'als du denkst.',
    sub: 'Jetzt für iOS verfügbar — Android folgt in Kürze.',
    soon: 'Bald',
    soonTitle: 'Der Link wird beim Launch hinzugefügt',
    live: 'Jetzt verfügbar',
  },
  faq: {
    eyebrow: 'Häufige Fragen',
    title: 'Fragen? Antworten.',
    items: [
      { q: 'Was ist KRUG?', a: 'KRUG ist eine mobile App für die Diaspora, die Menschen, Unternehmen, Events und Communities an einem Ort verbindet.' },
      { q: 'Für wen ist KRUG gedacht?', a: 'In erster Linie für Menschen aus Bosnien und Herzegowina und dem Balkan, die in der Diaspora leben — die Plattform ist aber für die breitere Community offen.' },
      { q: 'Wo wird KRUG verfügbar sein?', a: 'KRUG fokussiert sich auf Deutschland, Österreich und die Schweiz, mit geplanter Erweiterung auf den Rest Europas.' },
      { q: 'Was ist KRUG ISKRA?', a: 'KRUG ISKRA ist ein besonderes Modul für sinnvollere Begegnungen und Verbindungen — ohne endloses Swipen.' },
      { q: 'Ist KRUG eine Dating-App?', a: 'Nein. KRUG ist eine breitere soziale und lokale Plattform. KRUG ISKRA ist nur ein optionales Modul innerhalb der App.' },
      { q: 'Kann ich mein Unternehmen registrieren?', a: 'Ja. KRUG ist auch für Unternehmen und Dienstleistungen aus der Diaspora gemacht.' },
      { q: 'Wird KRUG kostenlos sein?', a: 'Die Grundfunktionen sollen kostenlos verfügbar sein. Premium-Funktionen können später eingeführt werden.' },
      { q: 'Wann kommt die App heraus?', a: 'KRUG befindet sich derzeit in der finalen Vorbereitung für den öffentlichen Launch. Trag dich in die Liste ein und wir benachrichtigen dich.' },
    ],
  },
  footer: {
    tagline: 'KRUG — die digitale Community für die Diaspora.',
    slogan: 'Finde deinen Kreis.',
    pagesTitle: 'Seiten',
    infoTitle: 'Info',
    nav: [
      { label: 'Start', href: '/#pocetna' },
      { label: 'So funktioniert’s', href: '/#kako-radi' },
      { label: 'KRUG ISKRA', href: '/#iskra' },
      { label: 'Unternehmen', href: '/#za-biznise' },
      { label: 'Events', href: '/#dogadjaji' },
      { label: 'FAQ', href: '/#faq' },
    ],
    legal: [
      { label: 'Kontakt', href: '/contact' },
      { label: 'Support', href: '/support' },
      { label: 'Datenschutz', href: '/privacy' },
      { label: 'Nutzungsbedingungen', href: '/terms' },
      { label: 'Community-Richtlinien', href: '/community-guidelines' },
    ],
    copyright: '© 2026 KRUG. Alle Rechte vorbehalten.',
    publisherLabel: 'Herausgeber',
    cookie: {
      text: 'Wir verwenden Cookies für den technischen Betrieb der Website und eine anonymisierte Reichweitenanalyse. Mit deiner Zustimmung hilfst du, KRUG besser zu machen.',
      accept: 'Akzeptieren',
      decline: 'Nur notwendige',
      more: 'Mehr erfahren',
      settings: 'Cookie-Einstellungen',
    },
    support: {
      title: 'Support',
      sub: 'Wir sind für dich da — schreib uns und wir antworten in der Regel innerhalb von 2 Werktagen.',
      emailTitle: 'Support-E-Mail',
      formTitle: 'Kontaktformular',
      labels: { name: 'Name', email: 'E-Mail', topic: 'Thema', message: 'Nachricht' },
      topics: ['Allgemeine Frage', 'Problem bei der Anmeldung', 'Unternehmensprofil', 'KRUG ISKRA', 'Daten & Datenschutz', 'Sonstiges'],
      placeholderMessage: 'Wie können wir dir helfen?',
      submit: 'Nachricht senden',
      successTitle: 'Nachricht gesendet!',
      successMsg: 'Danke für deine Nachricht — wir antworten dir so schnell wie möglich per E-Mail.',
      failToast: 'Senden fehlgeschlagen. Bitte versuche es erneut oder schreib direkt an info@krug-app.eu.',
      errors: { name: 'Bitte gib deinen Namen ein.', email: 'Bitte gib eine gültige E-Mail-Adresse ein.', message: 'Die Nachricht muss mindestens 10 Zeichen haben.' },
      helpTitle: 'Schnelle Hilfe',
      help: [
        { t: 'Bestätigungs-E-Mail nicht erhalten', d: 'Prüfe den Spam-/Werbeordner. Falls nichts da ist, melde dich mit derselben Adresse erneut an oder schreib uns.' },
        { t: 'Daten löschen', d: 'Sende deine Löschanfrage an info@krug-app.eu — wir antworten innerhalb der gesetzlichen Frist.' },
        { t: 'Unternehmensprofile', d: 'Du möchtest dein Unternehmen registrieren? Wähle im Formular das Thema "Unternehmensprofil" und wir senden dir die Details vor dem Launch.' },
        { t: 'Häufige Fragen', d: 'Antworten auf die häufigsten Fragen findest du im FAQ-Bereich auf der Startseite.', link: '/#faq', linkLabel: 'FAQ öffnen' },
      ],
    },
  },
  admin: {
    loginTitle: 'KRUG Admin',
    loginSub: 'Melde dich an, um die Anmeldungen zu sehen',
    email: 'E-Mail',
    password: 'Passwort',
    login: 'Anmelden',
    loginError: 'Falsche E-Mail oder falsches Passwort.',
    dashboard: 'Anmeldungen im Überblick',
    total: 'Anmeldungen gesamt',
    colName: 'Name',
    colEmail: 'E-Mail',
    colCity: 'Stadt',
    colCountry: 'Land',
    colNewsletter: 'News',
    colDate: 'Datum',
    exportCsv: 'CSV exportieren',
    adminsTitle: 'Admins',
    addAdminTitle: 'Neuen Admin hinzufügen',
    addAdminBtn: 'Admin hinzufügen',
    onlySuper: 'Nur der Haupt-Admin (Smajic) kann neue Admins hinzufügen.',
    added: 'Admin erfolgreich hinzugefügt.',
    exists: 'Dieser Admin existiert bereits.',
    logout: 'Abmelden',
    empty: 'Noch keine Anmeldungen.',
    yes: 'Ja',
    no: 'Nein',
    roleSuper: 'Haupt-Admin',
    roleAdmin: 'Admin',
    delete: 'Löschen',
    deleteConfirm: 'Anmeldung löschen für',
    deleted: 'Anmeldung gelöscht.',
    deleteFail: 'Löschen fehlgeschlagen.',
    statsTitle: 'Anmelde-Statistik',
    perDay: 'Anmeldungen pro Tag',
    perCountry: 'Verteilung nach Ländern',
    unknownCountry: 'Unbekannt',
    changePasswordTitle: 'Passwort ändern',
    currentPassword: 'Aktuelles Passwort',
    newPassword: 'Neues Passwort',
    changePasswordBtn: 'Passwort speichern',
    passwordChanged: 'Passwort erfolgreich geändert.',
    wrongCurrent: 'Aktuelles Passwort ist falsch.',
    remove: 'Entfernen',
    removeConfirm: 'Admin entfernen',
    removed: 'Admin entfernt.',
    removeFail: 'Entfernen fehlgeschlagen.',
    broadcastBtn: 'Launch-E-Mail senden',
    broadcastAndroidBtn: 'Android-Launch-E-Mail senden',
    broadcastAndroidConfirm: 'Android-Launch-E-Mail an ALLE auf der Warteliste senden?',
    broadcastConfirm: 'Launch-E-Mail an ALLE auf der Warteliste senden?',
    broadcastQueued: 'Launch-E-Mail wird gesendet an',
    broadcastFail: 'Versand konnte nicht gestartet werden.',
    supportTitle: 'Support-Nachrichten',
    supportEmpty: 'Keine Support-Nachrichten.',
    statusNew: 'Neu',
    statusRead: 'Gelesen',
    statusResolved: 'Gelöst',
    markRead: 'Gelesen',
    markResolved: 'Gelöst',
    replyBtn: 'Antworten',
    replyPlaceholder: 'Antwort an den Nutzer schreiben...',
    replySend: 'Antwort senden',
    replySent: 'Antwort an den Nutzer gesendet.',
    replyFail: 'Antwort konnte nicht gesendet werden.',
    filterAll: 'Alle',
    analyticsTitle: 'Besucher-Statistik',
    totalViews: 'Seitenaufrufe',
    totalClicks: 'Klicks',
    uniqueVisitors: 'Eindeutige Besucher',
    activeNow: 'Jetzt aktiv',
    viewsToday: 'Heute',
    viewsPerDay: 'Aufrufe (14 Tage)',
    topPages: 'Top-Seiten',
    topClicks: 'Top-Klicks',
    analyticsEmpty: 'Noch keine Daten — die Statistik wird erst nach Cookie-Zustimmung erhoben.',
    tickets: {
      tab: 'Tickets',
      overviewTab: 'Übersicht',
      title: 'Support-Tickets aus der App',
      all: 'Alle',
      open: 'Offen',
      answered: 'Beantwortet',
      closed: 'Geschlossen',
      refresh: 'Aktualisieren',
      loading: 'Tickets werden geladen...',
      empty: 'Keine Tickets für den gewählten Filter.',
      unavailable: 'Der Support-Service ist vorübergehend nicht erreichbar.',
      retry: 'Erneut versuchen',
      newLabel: 'Neu',
      back: 'Zurück zu den Tickets',
      statusOpen: 'Offen',
      statusAnswered: 'Beantwortet',
      statusClosed: 'Geschlossen',
      replyPlaceholder: 'Antwort an den Nutzer schreiben...',
      replySend: 'Antwort senden',
      replySent: 'Antwort wurde an den Nutzer gesendet.',
      replyFail: 'Antwort konnte nicht gesendet werden.',
      close: 'Ticket schließen',
      reopen: 'Ticket wieder öffnen',
      statusChanged: 'Ticket-Status wurde geändert.',
      statusFail: 'Status konnte nicht geändert werden.',
      support: 'KRUG Support',
    },
    app: {
      tabs: { overview: 'Übersicht', users: 'Nutzer', verifications: 'Verifizierungen', reports: 'Meldungen', finance: 'Finanzen', tickets: 'Tickets', audit: 'Audit', web: 'Web' },
      common: { refresh: 'Aktualisieren', loading: 'Wird geladen...', unavailable: 'Der App-Service ist vorübergehend nicht erreichbar.', retry: 'Erneut versuchen', empty: 'Keine Daten.' },
      stats: { title: 'App-Statistik', general: 'Allgemein', exportCsv: 'CSV herunterladen', days: 'Tage' },
      users: {
        title: 'App-Nutzer',
        searchPlaceholder: 'Suche nach Name oder E-Mail...',
        search: 'Suchen',
        colUser: 'Nutzer',
        colRole: 'Rolle',
        colStatus: 'Status',
        colVerified: 'Verifiziert',
        colDate: 'Registriert',
        actions: 'Aktionen',
        banned: 'Gesperrt',
        active: 'Aktiv',
        ban: 'Sperren',
        unban: 'Entsperren',
        banReason: 'Sperrgrund...',
        banConfirm: 'Nutzer sperren',
        unbanConfirm: 'Nutzer entsperren',
        roleSet: 'Rolle setzen',
        roleConfirm: 'Rolle ändern für',
        roleRegular: 'Nutzer',
        roleModerator: 'Moderator',
        roleSuper: 'Super-Admin',
        actionDone: 'Aktion erfolgreich ausgeführt.',
        actionFail: 'Aktion fehlgeschlagen.',
        empty: 'Keine Nutzer gefunden.',
      },
      verifications: {
        title: 'Verifizierungsanfragen',
        approve: 'Genehmigen',
        reject: 'Ablehnen',
        notePlaceholder: 'Notiz (bei Ablehnung erforderlich)...',
        noteRequired: 'Bei Ablehnung ist eine Notiz erforderlich.',
        approveConfirm: 'Verifizierung genehmigen für',
        rejectConfirm: 'Verifizierung ablehnen für',
        done: 'Anfrage bearbeitet.',
        fail: 'Aktion fehlgeschlagen.',
        empty: 'Keine ausstehenden Anfragen.',
      },
      reports: {
        title: 'Moderation',
        reportsTitle: 'Inhaltsmeldungen',
        appealsTitle: 'Nutzerbeschwerden',
        actDismiss: 'Meldung verwerfen',
        actWarn: 'Nutzer verwarnen',
        actRemove: 'Inhalt entfernen',
        actBan: 'Nutzer sperren',
        notePlaceholder: 'Notiz zur Aktion...',
        submit: 'Aktion ausführen',
        submitConfirm: 'Gewählte Aktion ausführen?',
        accept: 'Beschwerde annehmen',
        rejectAppeal: 'Beschwerde ablehnen',
        acceptConfirm: 'Beschwerde annehmen?',
        rejectConfirm: 'Beschwerde ablehnen?',
        done: 'Aktion erfolgreich ausgeführt.',
        fail: 'Aktion fehlgeschlagen.',
        emptyReports: 'Keine ausstehenden Meldungen.',
        emptyAppeals: 'Keine ausstehenden Beschwerden.',
      },
      finance: { title: 'Finanzen', empty: 'Keine Käufe erfasst.' },
      audit: { title: 'Audit-Log', empty: 'Keine Admin-Aktionen erfasst.' },
      fields: {
        users: 'Nutzer', content: 'Inhalte', finance: 'Finanzen', iskra: 'KRUG ISKRA',
        total: 'Gesamt', new_24h: 'Neu (24h)', new_7d: 'Neu (7 Tage)', new_30d: 'Neu (30 Tage)',
        verified: 'Verifiziert', banned: 'Gesperrt',
        posts: 'Beiträge', events: 'Events', businesses: 'Businesses', listings: 'Anzeigen',
        display_name: 'Name', name: 'Name', user_name: 'Nutzer', user_email: 'E-Mail', email: 'E-Mail',
        role: 'Rolle', status: 'Status', created_at: 'Datum', updated_at: 'Aktualisiert', last_message_at: 'Letzte Nachricht',
        amount: 'Betrag', currency: 'Währung', type: 'Typ', kind: 'Art', credits: 'Credits',
        action: 'Aktion', admin: 'Admin', admin_email: 'Admin', target: 'Ziel', note: 'Notiz', reason: 'Grund',
        subject: 'Betreff', message: 'Nachricht', count: 'Anzahl', revenue: 'Umsatz', purchases: 'Käufe',
        tickets: 'Tickets', category: 'Kategorie', category_label: 'Kategorie', description: 'Beschreibung',
        details: 'Details', source: 'Quelle',
      },
    },
  },
  legal: {
    back: 'Zurück zur Startseite',
    draft: 'Stand: August 2026',
    pdf: 'Als PDF herunterladen',
    pages: {
      privacy: {
        title: 'Datenschutzerklärung',
        sections: [
          { h: '1. Verantwortlicher', lines: ['Sandy Smajic, BSc IT', 'Sandy Smajic Consulting', 'Maxstr. 3, 45127 Essen, Deutschland', 'Telefon: +49 176 70035262', 'E-Mail (KRUG App und Datenschutzfragen): info@krug-app.eu', 'E-Mail (Consulting): info@sandysmajic.com'] },
          { h: '2. Geltungsbereich', p: 'Diese Datenschutzerklärung gilt für die mobile App KRUG (einschließlich des Moduls KRUG ISKRA) und die Website krug-app.eu. Sie erläutert, welche personenbezogenen Daten wir zu welchen Zwecken, auf welcher Rechtsgrundlage und für welche Dauer verarbeiten und welche Rechte Ihnen nach der Datenschutz-Grundverordnung (DSGVO) zustehen.' },
          { h: '3. Konto- und Registrierungsdaten', p: 'Bei der Registrierung verarbeiten wir die zur Erstellung und Verwaltung Ihres Kontos erforderlichen Daten: Anzeigename, E-Mail-Adresse, Passwort (ausschließlich als sicherer Hash gespeichert), Registrierungsdatum und Verifizierungsstatus des Kontos. Rechtsgrundlage ist die Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO).' },
          { h: '4. Profilinformationen', p: 'Daten, die Sie selbst in Ihr Profil eingeben (z. B. Name, Stadt, Land, Sprachen, Interessen, Beschreibung), verarbeiten wir, um Ihr Profil anzuzeigen und Vernetzungsfunktionen der Community zu ermöglichen (Art. 6 Abs. 1 lit. b DSGVO). Profildaten sind für andere Nutzer sichtbar, soweit dies die Funktionen erfordern — geben Sie nur preis, was Sie teilen möchten.' },
          { h: '5. Fotos und hochgeladene Medien', p: 'Fotos und sonstige Medien, die Sie hochladen (Profilfotos, Bilder zu Beiträgen, Events oder Unternehmensprofilen), werden auf unseren Servern gespeichert und entsprechend dem Zweck der Funktion in der App angezeigt. Sie können Medien entfernen, indem Sie den jeweiligen Inhalt oder Ihr gesamtes Konto löschen.' },
          { h: '6. Standortdaten', p: 'Wenn Sie in den Geräteeinstellungen den Zugriff auf den Standort erlauben, nutzen wir diesen, um Ihnen Menschen, Events und Unternehmen in Ihrer Nähe anzuzeigen. Der Standortzugriff ist freiwillig und kann jederzeit in den Geräteeinstellungen deaktiviert werden; die App funktioniert dann ohne standortbasierte Funktionen. Rechtsgrundlage: Ihre Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).' },
          { h: '7. Nachrichten und nutzergenerierte Inhalte', p: 'Nachrichten, Kommentare, Beiträge und sonstige von Ihnen erstellte Inhalte verarbeiten und zeigen wir, damit Kommunikation und Community funktionieren (Art. 6 Abs. 1 lit. b DSGVO). Den Inhalt von Nachrichten prüfen wir nur bei gemeldeten Verstößen, zur Moderation und Sicherheit der Nutzer (Art. 6 Abs. 1 lit. f DSGVO — berechtigtes Interesse).' },
          { h: '8. Voice Intro und Audioaufnahmen', p: 'Wenn Sie die Funktion Voice Intro nutzen, wird die von Ihnen erstellte Audioaufnahme gespeichert und im Rahmen Ihres Profils abgespielt, bis Sie sie selbst entfernen. Die Aufnahme ist ein Inhalt, den Sie freiwillig veröffentlichen; Rechtsgrundlage ist die Vertragserfüllung und Ihre Einwilligung (Art. 6 Abs. 1 lit. a und b DSGVO).' },
          { h: '9. KRUG ISKRA — Profil und Präferenzen', p: 'Das Modul KRUG ISKRA dient dem Kennenlernen und ist ausschließlich für Volljährige (18+) bestimmt. Daten, die Sie in Ihr ISKRA-Profil eingeben — einschließlich Dating-Präferenzen — können besondere Kategorien personenbezogener Daten offenbaren (z. B. die sexuelle Orientierung). Wir verarbeiten diese Daten ausschließlich auf Grundlage Ihrer ausdrücklichen Einwilligung (Art. 9 Abs. 2 lit. a DSGVO) und nur zum Zweck der Anzeige und des Matchings innerhalb des Moduls. Sie können Ihre Einwilligung jederzeit durch Löschen des ISKRA-Profils widerrufen, ohne Nachteile für die übrige App.' },
          { h: '10. Events und Community-Interaktionen', p: 'Beim Erstellen von Events, bei Zusagen, beim Beitritt zu Gruppen und bei Interaktionen mit Inhalten verarbeiten wir diese Daten zur Anzeige und Organisation gemeinschaftlicher Aktivitäten (Art. 6 Abs. 1 lit. b DSGVO).' },
          { h: '11. Unternehmensprofile und Einträge', p: 'Daten zu Unternehmen und Einträgen (Name, Kategorie, Kontakt, Standort, Beschreibung, Fotos) werden öffentlich in der App angezeigt. Wenn Sie ein Unternehmen registrieren, verarbeiten wir zusätzlich Ihre Kontaktdaten als Profilinhaber zur Verifizierung und Verwaltung (Art. 6 Abs. 1 lit. b DSGVO).' },
          { h: '12. Technische und Gerätedaten', p: 'Für Stabilität, Sicherheit und Fehlerbehebung verarbeiten wir technische Daten wie Gerätetyp, Betriebssystem, App-Version, IP-Adresse und Fehlerprotokolle (Art. 6 Abs. 1 lit. f DSGVO — berechtigtes Interesse am sicheren und stabilen Betrieb).' },
          { h: '13. Push-Benachrichtigungs-Tokens', p: 'Wenn Sie Push-Benachrichtigungen erlauben, speichern wir das technische Token Ihres Geräts, um Ihnen Benachrichtigungen senden zu können (z. B. zu neuen Nachrichten oder Antworten des Supports). Benachrichtigungen können Sie jederzeit in den Geräteeinstellungen deaktivieren (Art. 6 Abs. 1 lit. a und b DSGVO).' },
          { h: '14. Analyse und Cookies', p: 'Auf der Website verwenden wir eine eigene, anonymisierte Besuchsstatistik, ausschließlich mit Ihrer Einwilligung über das Cookie-Banner (Art. 6 Abs. 1 lit. a DSGVO); die Einwilligung können Sie über die Cookie-Einstellungen im Fußbereich der Website widerrufen. Wir setzen keine Werbe-Cookies Dritter ein, verfolgen Sie nicht zu Werbezwecken und verkaufen Ihre Daten nicht.' },
          { h: '15. In-App-Käufe und Abonnements', p: 'Käufe von Credits, Tickets und Abonnements werden über die App Stores abgewickelt. Apple (App Store) und Google (Google Play) verarbeiten die Zahlung als eigenständig Verantwortliche im Rahmen ihrer eigenen Bedingungen und Datenschutzerklärungen; wir erhalten lediglich eine Kaufbestätigung (z. B. Art und Zeitpunkt), ohne Angaben zu Ihrem Zahlungsmittel. Rechtsgrundlage: Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO).' },
          { h: '16. Dienstleister und Empfänger', p: 'Für den technischen Betrieb setzen wir sorgfältig ausgewählte Dienstleister ein: Hosting und Backend-Infrastruktur (Emergent-Plattform) sowie den Versand von E-Mails der Website (Resend). Dienstleister verarbeiten Daten ausschließlich auf Grundlage von Auftragsverarbeitungsverträgen und nach unserer Weisung. Wir verkaufen Ihre Daten nicht und geben sie nicht zu Marketingzwecken an Dritte weiter.' },
          { h: '17. Datenübermittlung in Drittländer', p: 'Sollte ein Dienstleister Daten außerhalb der Europäischen Union verarbeiten, erfolgt dies nur mit den von der DSGVO vorgesehenen Garantien (z. B. Standardvertragsklauseln, Art. 46 DSGVO).' },
          { h: '18. Speicherdauer', p: 'Kontodaten speichern wir, solange das Konto besteht. Nach Kontolöschung löschen oder anonymisieren wir personenbezogene Daten, soweit wir nicht gesetzlich zur Aufbewahrung verpflichtet sind (z. B. steuer- und handelsrechtliche Pflichten bei Käufen — bis zu 10 Jahre nach deutschem Recht). Technische Serverprotokolle werden nur kurzfristig gespeichert. Daten der Warteliste speichern wir bis zum App-Launch und einer angemessenen Frist danach bzw. bis zum Widerruf der Einwilligung.' },
          { h: '19. Kontolöschung', p: 'Die Löschung Ihres Kontos können Sie jederzeit per E-Mail an info@krug-app.eu beantragen — Konto und zugehörige personenbezogene Daten (Profil, Fotos, Aufnahmen, Nachrichten, ISKRA-Daten) löschen wir ohne unangemessene Verzögerung, ausgenommen Daten, die wir gesetzlich aufbewahren müssen.' },
          { h: '20. Ihre Rechte', lines: ['Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO)', 'Berichtigung unrichtiger Daten (Art. 16 DSGVO)', 'Löschung Ihrer Daten (Art. 17 DSGVO)', 'Einschränkung der Verarbeitung (Art. 18 DSGVO)', 'Datenübertragbarkeit (Art. 20 DSGVO)', 'Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)', 'Widerruf erteilter Einwilligungen jederzeit und ohne Nachteile (Art. 7 Abs. 3 DSGVO)', 'Beschwerde bei der Aufsichtsbehörde: Landesbeauftragte für Datenschutz und Informationsfreiheit NRW, Deutschland (Art. 77 DSGVO)', 'Zur Ausübung Ihrer Rechte genügt eine E-Mail an info@krug-app.eu'] },
          { h: '21. Datensicherheit', p: 'Wir setzen angemessene technische und organisatorische Maßnahmen ein: TLS-Verschlüsselung der Übertragung, sicheres Hashing von Passwörtern und Zugriffsbeschränkung auf berechtigte Personen. Bitte beachten Sie, dass kein System absolute Sicherheit garantieren kann.' },
          { h: '22. Minderjährige', p: 'Die App KRUG richtet sich an Personen über 16 Jahre; das Modul KRUG ISKRA ist ausschließlich für Volljährige (18+) bestimmt. Wir erheben wissentlich keine Daten Minderjähriger unterhalb der zulässigen Grenze; werden uns solche Konten bekannt, löschen wir sie.' },
          { h: '23. Sperren, Meldungen und Moderation', p: 'Zur Sicherheit der Community verarbeiten wir Meldungen von Verstößen, Sperrungen und Beschwerden (einschließlich des gemeldeten Inhalts und der Daten beteiligter Nutzer) sowie administrative Maßnahmen wie Verwarnungen oder Kontosperrungen (Art. 6 Abs. 1 lit. f DSGVO — berechtigtes Interesse an einer sicheren Community).' },
          { h: '24. Änderungen dieser Erklärung', p: 'Wir können diese Datenschutzerklärung gelegentlich aktualisieren, etwa wenn sich Funktionen der App ändern. Die aktuelle Version ist stets auf dieser Seite veröffentlicht; über wesentliche Änderungen informieren wir Nutzer in der App oder per E-Mail.' },
          { h: '25. Kontakt bei Datenschutzfragen', p: 'Bei Fragen, Anträgen und Widersprüchen zum Datenschutz schreiben Sie uns an info@krug-app.eu oder postalisch an die in Ziffer 1 genannte Adresse. Wir antworten in der Regel innerhalb von 30 Tagen.' },
        ],
      },
      terms: {
        title: 'Nutzungsbedingungen',
        sections: [
          { h: '1. Geltungsbereich', p: 'Diese Nutzungsbedingungen gelten für die mobile App KRUG (einschließlich des Moduls KRUG ISKRA) und die Website krug-app.eu. Mit der Nutzung der App oder Website akzeptieren Sie diese Bedingungen. Die Verhaltensregeln der Gemeinschaft regeln zusätzlich die Community-Richtlinien.' },
          { h: '2. Anbieter', lines: ['Sandy Smajic Consulting', 'Sandy Smajic, BSc IT', 'Maxstr. 3, 45127 Essen, Deutschland', 'Telefon: +49 176 70035262', 'E-Mail (KRUG App): info@krug-app.eu', 'E-Mail (Consulting): info@sandysmajic.com'] },
          { h: '3. Leistungsbeschreibung', p: 'KRUG ist eine Social- und Community-Plattform für die Diaspora: Menschen vernetzen, Unternehmen und Events entdecken, Gruppen und Communities, Minispiele sowie das Modul KRUG ISKRA zum Kennenlernen. Die Website dient der Vorstellung der App und der Anmeldung zur Warteliste; die Wartelisten-Anmeldung ist kostenlos und unverbindlich und begründet kein Vertragsverhältnis.' },
          { h: '4. Registrierung und Konto', p: 'Die App richtet sich an Personen über 16 Jahre; das Modul KRUG ISKRA ist ausschließlich für Volljährige (18+) bestimmt. Sie versichern, dass Ihre Registrierungsdaten zutreffend sind, halten Ihre Zugangsdaten geheim und teilen Ihr Konto nicht mit Dritten. Das Erstellen von Konten für Dritte ohne deren Einwilligung und falsche Identitäten sind untersagt.' },
          { h: '5. Nutzerinhalte', p: 'Sie behalten alle Rechte an den von Ihnen veröffentlichten Inhalten (Text, Fotos, Audio, Events, Einträge). Mit der Veröffentlichung räumen Sie uns ein nicht-exklusives, unentgeltliches, räumlich unbeschränktes Recht ein, diese Inhalte innerhalb der App anzuzeigen und technisch zu verarbeiten — bis Sie den Inhalt oder Ihr Konto löschen. Sie sind dafür verantwortlich, dass Ihre Inhalte keine Gesetze oder Rechte Dritter verletzen; verbotene Inhalte sind in den Community-Richtlinien aufgeführt. Wir behalten uns vor, Inhalte zu entfernen, die gegen diese Bedingungen verstoßen.' },
          { h: '6. Zusätzliche Regeln für KRUG ISKRA', p: 'Das ISKRA-Modul ist nur für Volljährige (18+) zugänglich. Respektvolle und freiwillige Kommunikation ist verpflichtend; untersagt sind explizite Inhalte, Druck, Belästigung, kommerzielle Kontaktanbahnung, Betrug und Erpressung. Verstöße führen zur Entfernung von Inhalten, Sperrung oder dauerhaften Löschung des Kontos.' },
          { h: '7. Events und Unternehmen Dritter', p: 'Events, Unternehmensprofile und Einträge werden von Nutzern und Dritten erstellt; für deren Richtigkeit, Qualität und Rechtmäßigkeit sind die jeweiligen Veranstalter und Inhaber verantwortlich. Die Teilnahme an Events und Geschäftsbeziehungen mit Dritten erfolgen auf eigene Verantwortung.' },
          { h: '8. Käufe, Credits und Abonnements', p: 'Käufe von Credits, Tickets und Abonnements werden über die App Stores (Apple App Store bzw. Google Play) abgerechnet; es gelten deren Zahlungsbedingungen. Preise und Leistungsumfang werden vor dem Kauf angezeigt. Credits sind eine virtuelle Einheit ohne Geldwert: Sie können nicht in Bargeld umgetauscht, auf andere Konten übertragen oder außerhalb der Regeln der App Stores erstattet werden. Abonnements verlängern sich automatisch, bis sie in den Einstellungen Ihres Store-Kontos gekündigt werden; Kündigung und Erstattungen erfolgen ausschließlich über das Apple- bzw. Google-Konto. Preisänderungen kündigen wir vorab in der App an.' },
          { h: '9. Moderation, Sperrung und Kündigung', p: 'Zur Sicherheit der Community können wir bei Verstößen gegen diese Bedingungen oder die Community-Richtlinien verwarnen, Konten vorübergehend sperren oder dauerhaft entfernen sowie Inhalte löschen — mit der Möglichkeit einer Beschwerde in der App. Sie können die Nutzung jederzeit durch Löschen Ihres Kontos beenden; laufende Abonnements enden dabei nach den Regeln des jeweiligen Stores.' },
          { h: '10. Verfügbarkeit und Leistungsänderungen', p: 'Wir bemühen uns um eine ständige Verfügbarkeit, garantieren jedoch keinen unterbrechungsfreien Betrieb (z. B. Wartung, technische Störungen). Funktionen der App können wir weiterentwickeln, ändern oder einstellen; über wesentliche Änderungen informieren wir in der App.' },
          { h: '11. Haftung', p: 'Wir haften unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie bei Verletzung von Leben, Körper oder Gesundheit. Bei leichter Fahrlässigkeit haften wir nur bei Verletzung wesentlicher Vertragspflichten, begrenzt auf den vorhersehbaren Schaden. Für Inhalte von Nutzern und Dritten haften wir nicht. Die Vorschriften des Produkthaftungsgesetzes und zwingende Verbraucherrechte bleiben unberührt.' },
          { h: '12. Geistiges Eigentum', p: 'Der Name KRUG, das Logo, Design, Texte und der Programmcode der App und Website sind Eigentum des Anbieters und dürfen ohne schriftliche Genehmigung nicht vervielfältigt oder verwendet werden.' },
          { h: '13. Änderungen der Bedingungen', p: 'Wir können diese Bedingungen mit Hinweis in der App oder per E-Mail ändern; wesentliche Änderungen kündigen wir angemessen vorab an. Mit der fortgesetzten Nutzung nach Inkrafttreten akzeptieren Sie die neue Version; bei Widerspruch können Sie Ihr Konto löschen.' },
          { h: '14. Anwendbares Recht und Gerichtsstand', p: 'Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des Kollisionsrechts; Verbrauchern bleiben die zwingenden Schutzvorschriften ihres Aufenthaltsstaates gewahrt. Gerichtsstand ist, soweit gesetzlich zulässig, Essen.' },
          { h: '15. Kontakt', p: 'Bei Fragen zu diesen Bedingungen schreiben Sie an info@krug-app.eu — wir antworten in der Regel innerhalb von 2 Werktagen.' },
        ],
      },
      'community-guidelines': {
        title: 'Community-Richtlinien',
        sections: [
          { h: 'Zweck der Gemeinschaft', p: 'KRUG bringt Menschen der Diaspora, ihre Unternehmen, Events und Communities zusammen. Diese Richtlinien gelten für alle Nutzer der App und schützen Sicherheit und Qualität der Gemeinschaft.' },
          { h: 'Respekt und Verhalten', p: 'Wir tolerieren keine Hassrede, Diskriminierung, Belästigung, Drohungen oder Beleidigungen — unabhängig von Nationalität, Religion, Geschlecht oder Herkunft. Kommunizieren Sie so, wie Sie selbst behandelt werden möchten.' },
          { h: 'Authentizität', p: 'Profile, Unternehmen und Events müssen echt und zutreffend sein. Falsche Identitäten, Betrug, Spam und unerlaubte Werbung führen zur Entfernung von Inhalten oder Konten.' },
          { h: 'Zusätzliche Regeln für KRUG ISKRA', p: 'Das ISKRA-Modul ist ausschließlich für volljährige Personen (18+) bestimmt. Respektvolle Kommunikation und die Wahrung der Grenzen anderer Nutzer sind verpflichtend; explizite Inhalte und Druck sind untersagt.' },
          { h: 'Verbotene Inhalte', p: 'Untersagt sind rechtswidrige Inhalte, Gewalt, explizites Material, Daten Dritter ohne deren Einwilligung sowie Inhalte, die Rechte an geistigem Eigentum verletzen.' },
          { h: 'Verstöße melden', p: 'Melden Sie Inhalte und Nutzer, die gegen die Richtlinien verstoßen, direkt in der App oder per E-Mail an info@krug-app.eu. Jede Meldung wird vertraulich geprüft.' },
          { h: 'Maßnahmen und Konsequenzen', p: 'Je nach Schwere des Verstoßes setzen wir Verwarnungen, vorübergehende Sperrungen oder dauerhafte Entfernung des Kontos ein und informieren ggf. die zuständigen Behörden.' },
          { h: 'Änderungen dieser Richtlinien', p: 'Wir können diese Richtlinien gelegentlich aktualisieren; die aktuelle Version ist auf dieser Seite veröffentlicht.' },
        ],
      },
      contact: {
        title: 'Kontakt',
        sections: [
          { h: 'Angaben gemäß § 5 DDG', lines: ['Sandy Smajic Consulting', 'Sandy Smajic, BSc IT', 'Maxstr. 3', '45127 Essen', 'Deutschland'] },
          { h: 'Kontakt', lines: ['Telefon: +49 176 70035262', 'E-Mail (KRUG App): info@krug-app.eu', 'E-Mail (Consulting): info@sandysmajic.com'] },
          { h: 'Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV', lines: ['Sandy Smajic', 'Anschrift wie oben'] },
          { h: 'Geschäftliche Anfragen', p: 'Für Kooperationen, Unternehmensprofile, Events und Medienanfragen schreiben Sie uns per E-Mail — wir antworten in der Regel innerhalb von 2 Werktagen.' },
        ],
      },
    },
  },
};

const en = {
  nav: {
    links: [
      { label: 'Home', href: '#pocetna', testid: 'nav-link-pocetna' },
      { label: 'How it works', href: '#kako-radi', testid: 'nav-link-kako-radi' },
      { label: 'Features', href: '#funkcije', testid: 'nav-link-funkcije' },
      { label: 'KRUG ISKRA', href: '#iskra', testid: 'nav-link-iskra' },
      { label: 'For Businesses', href: '#za-biznise', testid: 'nav-link-za-biznise' },
      { label: 'FAQ', href: '#faq', testid: 'nav-link-faq' },
    ],
    cta: 'Be first to join',
    soonTitle: 'Coming soon',
  },
  hero: {
    eyebrow: 'KRUG for the diaspora',
    titleA: 'Find your',
    titleB: 'circle.',
    sub: 'People, businesses, events and new connections in the diaspora — all in one place.',
    supporting: 'KRUG connects the diaspora through community, local businesses, events and meaningful connections.',
    ctaPrimary: 'Be first to join',
    ctaSecondary: 'See the app',
    storeNote: 'Now available for iOS · Android coming soon',
    storeSoon: 'Coming soon',
    storeLive: 'Download now',
    countdownTitle: 'Android version in',
    cDays: 'days',
    cHours: 'hrs',
    cMins: 'min',
    cSecs: 'sec',
    launchedTitle: 'KRUG has arrived!',
    launchedSub: 'Available for iOS and Android — download the app and find your circle.',
  },
  marquee: ['People', 'Businesses', 'Events', 'Communities', 'KRUG ISKRA', 'Find your circle'],
  valueStrip: [
    { icon: MapPin, label: 'People near you' },
    { icon: Briefcase, label: 'Businesses from the diaspora' },
    { icon: CalendarDays, label: 'Events & communities' },
    { icon: Sparkles, label: 'KRUG ISKRA' },
  ],
  whatIs: {
    eyebrow: 'What is KRUG',
    title: 'Everything the diaspora needs — in one circle.',
    copy: 'Today, people, businesses, events and communities are scattered across dozens of Facebook groups, pages and apps. KRUG brings them together in one place.',
  },
  cards: [
    { icon: Users, title: 'People', copy: 'Find people from your hometown, city or area and connect through shared interests.', preview: ['Sarajevo → Munich', 'Shared interests', 'Private messages'] },
    { icon: Briefcase, title: 'Businesses', copy: 'Discover restaurants, companies, services and entrepreneurs from the diaspora.', preview: ['Restaurants · Essen', 'Verified profiles', 'Community ratings'] },
    { icon: CalendarDays, title: 'Events', copy: 'Find concerts, meetups, trips and local gatherings.', preview: ['Concerts & meetups', 'Trips', 'Local happenings'] },
    { icon: UsersRound, title: 'Communities', copy: 'Join groups and meet people who share your interests.', preview: ['Interest-based groups', 'Local communities', 'Active members'] },
  ],
  showcase: {
    eyebrow: 'Inside look',
    title: 'KRUG from the inside.',
    copy: 'Simple to use. Built for real life in the diaspora.',
    tabsAria: 'App screens',
    tabs: showcaseTabs(
      ['Home', 'Explore', 'Businesses', 'KRUG ISKRA', 'Mini-games'],
      [
        'Your day in the diaspora — events, businesses and your circle nearby.',
        'Search people, businesses and happenings across the diaspora.',
        'Restaurants, companies and services — with ratings and featured profiles.',
        'Today’s circle — up to 5 carefully chosen people every day.',
        'Mini-games, Voice intro, How would you? — getting to know each other through play.',
      ],
    ),
  },
  people: {
    eyebrow: 'People',
    title: 'Find your people.',
    copy: 'A new city doesn’t have to mean starting over without familiar faces. KRUG helps you find people from your hometown, with similar interests, and from the community you live in.',
    highlights: ['Search by city and area', 'Shared interests', 'Local communities', 'Private messages', 'Privacy controls'],
    cta: 'Enter your circle',
  },
  business: {
    eyebrow: 'For businesses',
    title: 'Our businesses. Easier to find.',
    copy: 'From restaurants and construction companies to IT, transport, healthcare and administrative services — KRUG gives diaspora businesses a place where their community can find them.',
    features: [
      { icon: Search, label: 'Search by city' },
      { icon: Briefcase, label: 'Categories' },
      { icon: Star, label: 'Ratings' },
      { icon: Sparkles, label: 'Featured businesses' },
      { icon: ShieldCheck, label: 'Verified profiles' },
      { icon: MessageCircle, label: 'Direct contact' },
      { icon: Eye, label: 'Local visibility' },
    ],
    boxTitle: 'Have a business? KRUG is for you too.',
    boxCta: 'Learn more',
  },
  events: {
    eyebrow: 'Events',
    title: 'What’s happening in your city?',
    copy: 'Concerts, meetups, trips, business events, family gatherings and local happenings — without digging through dozens of groups.',
    cards: [
      { icon: Music, tag: 'Concerts', copy: 'Gigs, parties and music nights in your city.' },
      { icon: Coffee, tag: 'Meetups', copy: 'Coffee, iftars, sevdah nights and spontaneous get-togethers.' },
      { icon: BusFront, tag: 'Trips', copy: 'Group travels, excursions and weekend tours.' },
      { icon: Handshake, tag: 'Business & family', copy: 'Networking events, fairs and family gatherings.' },
    ],
    highlights: ['Events nearby', 'Local recommendations', 'Organizers', 'RSVPs', 'Reminders', 'Community events'],
  },
  iskra: {
    eyebrow: 'A special module within KRUG',
    sub: 'Don’t choose a picture. Recognize the person.',
    copy: 'KRUG ISKRA is made for those who want more meaningful connections. Less endless swiping, more real interaction through interests, values and lifestyle.',
    features: [
      { icon: Zap, title: 'Today’s circle', copy: 'Up to 5 carefully selected recommendations per day.' },
      { icon: Mic, title: 'Voice intro', copy: 'Get to know someone’s voice and energy before the first conversation.' },
      { icon: HelpCircle, title: 'How would you?', copy: 'Questions and real-life situations that reveal how well you match.' },
      { icon: Gamepad2, title: 'Mini-games', copy: 'Get to know each other through short shared challenges.' },
      { icon: Users, title: 'Circle rooms', copy: 'Small group sessions for more natural connections.' },
      { icon: ShieldCheck, title: 'Safety', copy: 'Privacy controls, reporting and safety features.' },
    ],
    statementA: 'Fewer matches. ',
    statementB: 'More real encounters.',
    cta: 'Discover KRUG ISKRA',
  },
  miniGames: {
    eyebrow: 'Mini-games',
    title: 'Connecting can be more fun.',
    copy: 'Mini-games within KRUG ISKRA let people get to know each other through choices, priorities and shared situations — without awkward first questions.',
    tags: ['Choosing together', 'Our weekend', 'Three priorities', 'This or that', 'Balkan soul', 'Emoji story'],
  },
  why: {
    eyebrow: 'Why KRUG',
    title: 'Why KRUG?',
    items: [
      { icon: MapPin, title: 'Closeness', copy: 'Find people and events where you actually live.' },
      { icon: Heart, title: 'Community', copy: 'Stay connected with your people even far from home.' },
      { icon: Eye, title: 'Visibility', copy: 'Support businesses and people from your community.' },
      { icon: Sparkles, title: 'New connections', copy: 'From friendships and business contacts to something more.' },
    ],
    noteA: 'KRUG is just getting started. ',
    noteB: 'Be among the first.',
  },
  who: {
    eyebrow: 'Who it’s for',
    title: 'KRUG is yours — however you use it.',
    cards: [
      { icon: UserRound, title: 'For people', copy: 'New connections, local community and an easier life in the diaspora.' },
      { icon: Briefcase, title: 'For businesses', copy: 'Visibility where your customers are.' },
      { icon: Megaphone, title: 'For organizers', copy: 'Promote your events directly to a relevant audience.' },
    ],
    linkLabel: 'Join the waitlist',
  },
  waitlist: {
    eyebrow: 'Early access',
    title: 'Be among the first in KRUG.',
    copy: 'KRUG is coming soon. Leave your email and we’ll let you know when the app is available.',
    labels: { name: 'Name', email: 'Email', city: 'City', country: 'Country', optional: '(optional)' },
    placeholders: { name: 'Your name', email: 'name@email.com', city: 'e.g. Munich', country: 'e.g. Germany' },
    errors: { name: 'Please enter your name.', email: 'Please enter a valid email address.' },
    newsletter: 'I want to receive news about the KRUG app.',
    submit: 'Join the waitlist',
    gdprBefore: 'By submitting you agree that KRUG (publisher: Sandy Smajic Consulting) uses your data exclusively to notify you about the app launch and — only if checked — for KRUG news. Data is never shared with third parties and you can request deletion at any time. More on the ',
    gdprLink: 'Privacy',
    gdprAfter: ' page.',
    successTitle: 'Welcome to KRUG.',
    successMsg: 'We’ll let you know when we launch.',
    duplicateMsg: 'This email is already on the list — we’ll let you know when we launch.',
    failToast: 'Something went wrong. Please try again in a moment.',
  },
  store: {
    titleA: 'Your circle is closer ',
    titleB: 'than you think.',
    sub: 'Now available for iOS — Android coming soon.',
    soon: 'Soon',
    soonTitle: 'The link will be added at launch',
    live: 'Available now',
  },
  faq: {
    eyebrow: 'Frequently asked questions',
    title: 'Questions? Answers.',
    items: [
      { q: 'What is KRUG?', a: 'KRUG is a mobile app for the diaspora that connects people, businesses, events and communities in one place.' },
      { q: 'Who is it for?', a: 'Primarily for people from Bosnia and Herzegovina and the Balkans living in the diaspora, but the platform is open to the wider community.' },
      { q: 'Where will KRUG be available?', a: 'KRUG is focused on Germany, Austria and Switzerland, with planned expansion to the rest of Europe.' },
      { q: 'What is KRUG ISKRA?', a: 'KRUG ISKRA is a special module for more meaningful connections — without endless swiping.' },
      { q: 'Is KRUG a dating app?', a: 'No. KRUG is a broader social and local platform. KRUG ISKRA is just one optional module within the app.' },
      { q: 'Can I register my business?', a: 'Yes. KRUG is designed for businesses and services from the diaspora too.' },
      { q: 'Will KRUG be free?', a: 'Core features are intended to be free. Premium features may be introduced later.' },
      { q: 'When does the app launch?', a: 'KRUG is currently in final preparation for public launch. Join the waitlist and we’ll notify you when it’s available.' },
    ],
  },
  footer: {
    tagline: 'KRUG — the digital community for the diaspora.',
    slogan: 'Find your circle.',
    pagesTitle: 'Pages',
    infoTitle: 'Info',
    nav: [
      { label: 'Home', href: '/#pocetna' },
      { label: 'How it works', href: '/#kako-radi' },
      { label: 'KRUG ISKRA', href: '/#iskra' },
      { label: 'Businesses', href: '/#za-biznise' },
      { label: 'Events', href: '/#dogadjaji' },
      { label: 'FAQ', href: '/#faq' },
    ],
    legal: [
      { label: 'Contact', href: '/contact' },
      { label: 'Support', href: '/support' },
      { label: 'Privacy', href: '/privacy' },
      { label: 'Terms of Use', href: '/terms' },
      { label: 'Community Guidelines', href: '/community-guidelines' },
    ],
    copyright: '© 2026 KRUG. All rights reserved.',
    publisherLabel: 'Publisher',
    cookie: {
      text: 'We use cookies for the technical operation of the website and anonymized reach analysis. Accepting helps make KRUG better.',
      accept: 'Accept',
      decline: 'Only necessary',
      more: 'Learn more',
      settings: 'Cookie settings',
    },
    support: {
      title: 'Support',
      sub: 'We are here to help — message us and we typically reply within 2 business days.',
      emailTitle: 'Support email',
      formTitle: 'Contact form',
      labels: { name: 'Name', email: 'Email', topic: 'Topic', message: 'Message' },
      topics: ['General question', 'Signup problem', 'Business profile', 'KRUG ISKRA', 'Data & privacy', 'Other'],
      placeholderMessage: 'How can we help you?',
      submit: 'Send message',
      successTitle: 'Message sent!',
      successMsg: 'Thanks for reaching out — we will reply to your email as soon as possible.',
      failToast: 'Sending failed. Please try again or write directly to info@krug-app.eu.',
      errors: { name: 'Please enter your name.', email: 'Please enter a valid email address.', message: 'The message must be at least 10 characters.' },
      helpTitle: 'Quick help',
      help: [
        { t: 'Confirmation email not received', d: 'Check your spam/promotions folder. If nothing is there, sign up again with the same address or message us.' },
        { t: 'Delete my data', d: 'Send your deletion request to info@krug-app.eu — we respond within the legal timeframe.' },
        { t: 'Business profiles', d: 'Want to register your business? Choose the "Business profile" topic in the form and we will send you the details before launch.' },
        { t: 'Frequently asked questions', d: 'Find answers to the most common questions in the FAQ section on the homepage.', link: '/#faq', linkLabel: 'Open FAQ' },
      ],
    },
  },
  admin: {
    loginTitle: 'KRUG Admin',
    loginSub: 'Sign in to view waitlist signups',
    email: 'Email',
    password: 'Password',
    login: 'Sign in',
    loginError: 'Wrong email or password.',
    dashboard: 'Waitlist signups',
    total: 'Total signups',
    colName: 'Name',
    colEmail: 'Email',
    colCity: 'City',
    colCountry: 'Country',
    colNewsletter: 'News',
    colDate: 'Date',
    exportCsv: 'Export CSV',
    adminsTitle: 'Admins',
    addAdminTitle: 'Add new admin',
    addAdminBtn: 'Add admin',
    onlySuper: 'Only the main admin (Smajic) can add new admins.',
    added: 'Admin added successfully.',
    exists: 'This admin already exists.',
    logout: 'Sign out',
    empty: 'No signups yet.',
    yes: 'Yes',
    no: 'No',
    roleSuper: 'main admin',
    roleAdmin: 'admin',
    delete: 'Delete',
    deleteConfirm: 'Delete signup for',
    deleted: 'Signup deleted.',
    deleteFail: 'Delete failed.',
    statsTitle: 'Signup statistics',
    perDay: 'Signups per day',
    perCountry: 'Distribution by country',
    unknownCountry: 'Unknown',
    changePasswordTitle: 'Change password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    changePasswordBtn: 'Save password',
    passwordChanged: 'Password changed successfully.',
    wrongCurrent: 'Current password is wrong.',
    remove: 'Remove',
    removeConfirm: 'Remove admin',
    removed: 'Admin removed.',
    removeFail: 'Remove failed.',
    broadcastBtn: 'Send launch email',
    broadcastAndroidBtn: 'Send Android launch email',
    broadcastAndroidConfirm: 'Send Android launch email to EVERYONE on the waitlist?',
    broadcastConfirm: 'Send launch email to EVERYONE on the waitlist?',
    broadcastQueued: 'Launch email is being sent to',
    broadcastFail: 'Broadcast could not be started.',
    supportTitle: 'Support messages',
    supportEmpty: 'No support messages.',
    statusNew: 'New',
    statusRead: 'Read',
    statusResolved: 'Resolved',
    markRead: 'Mark read',
    markResolved: 'Mark resolved',
    replyBtn: 'Reply',
    replyPlaceholder: 'Write a reply to the user...',
    replySend: 'Send reply',
    replySent: 'Reply sent to the user.',
    replyFail: 'Reply could not be sent.',
    filterAll: 'All',
    analyticsTitle: 'Visitor statistics',
    totalViews: 'Page views',
    totalClicks: 'Clicks',
    uniqueVisitors: 'Unique visitors',
    activeNow: 'Active now',
    viewsToday: 'Today',
    viewsPerDay: 'Views (14 days)',
    topPages: 'Top pages',
    topClicks: 'Top clicks',
    analyticsEmpty: 'No data yet — statistics are only collected after cookie consent.',
    tickets: {
      tab: 'Tickets',
      overviewTab: 'Overview',
      title: 'Support tickets from the app',
      all: 'All',
      open: 'Open',
      answered: 'Answered',
      closed: 'Closed',
      refresh: 'Refresh',
      loading: 'Loading tickets...',
      empty: 'No tickets for the selected filter.',
      unavailable: 'The support service is currently unavailable.',
      retry: 'Try again',
      newLabel: 'New',
      back: 'Back to tickets',
      statusOpen: 'Open',
      statusAnswered: 'Answered',
      statusClosed: 'Closed',
      replyPlaceholder: 'Write a reply to the user...',
      replySend: 'Send reply',
      replySent: 'Reply sent to the user.',
      replyFail: 'Failed to send the reply.',
      close: 'Close ticket',
      reopen: 'Reopen ticket',
      statusChanged: 'Ticket status updated.',
      statusFail: 'Failed to update the status.',
      support: 'KRUG Support',
    },
    app: {
      tabs: { overview: 'Overview', users: 'Users', verifications: 'Verifications', reports: 'Reports', finance: 'Finance', tickets: 'Tickets', audit: 'Audit', web: 'Web' },
      common: { refresh: 'Refresh', loading: 'Loading...', unavailable: 'The app service is currently unavailable.', retry: 'Try again', empty: 'No data.' },
      stats: { title: 'App statistics', general: 'General', exportCsv: 'Download CSV', days: 'days' },
      users: {
        title: 'App users',
        searchPlaceholder: 'Search by name or email...',
        search: 'Search',
        colUser: 'User',
        colRole: 'Role',
        colStatus: 'Status',
        colVerified: 'Verified',
        colDate: 'Registered',
        actions: 'Actions',
        banned: 'Banned',
        active: 'Active',
        ban: 'Ban',
        unban: 'Unban',
        banReason: 'Ban reason...',
        banConfirm: 'Ban user',
        unbanConfirm: 'Unban user',
        roleSet: 'Set role',
        roleConfirm: 'Change role for',
        roleRegular: 'User',
        roleModerator: 'Moderator',
        roleSuper: 'Super admin',
        actionDone: 'Action completed successfully.',
        actionFail: 'Action failed.',
        empty: 'No users to display.',
      },
      verifications: {
        title: 'Verification requests',
        approve: 'Approve',
        reject: 'Reject',
        notePlaceholder: 'Note (required when rejecting)...',
        noteRequired: 'A note is required when rejecting.',
        approveConfirm: 'Approve verification for',
        rejectConfirm: 'Reject verification for',
        done: 'Request processed.',
        fail: 'Action failed.',
        empty: 'No pending requests.',
      },
      reports: {
        title: 'Moderation',
        reportsTitle: 'Content reports',
        appealsTitle: 'User appeals',
        actDismiss: 'Dismiss report',
        actWarn: 'Warn user',
        actRemove: 'Remove content',
        actBan: 'Ban user',
        notePlaceholder: 'Note for the action...',
        submit: 'Execute action',
        submitConfirm: 'Execute the selected action?',
        accept: 'Accept appeal',
        rejectAppeal: 'Reject appeal',
        acceptConfirm: 'Accept the appeal?',
        rejectConfirm: 'Reject the appeal?',
        done: 'Action completed successfully.',
        fail: 'Action failed.',
        emptyReports: 'No pending reports.',
        emptyAppeals: 'No pending appeals.',
      },
      finance: { title: 'Finance', empty: 'No purchases recorded.' },
      audit: { title: 'Audit log', empty: 'No admin actions recorded.' },
      fields: {
        users: 'Users', content: 'Content', finance: 'Finance', iskra: 'KRUG ISKRA',
        total: 'Total', new_24h: 'New (24h)', new_7d: 'New (7 days)', new_30d: 'New (30 days)',
        verified: 'Verified', banned: 'Banned',
        posts: 'Posts', events: 'Events', businesses: 'Businesses', listings: 'Listings',
        display_name: 'Name', name: 'Name', user_name: 'User', user_email: 'Email', email: 'Email',
        role: 'Role', status: 'Status', created_at: 'Date', updated_at: 'Updated', last_message_at: 'Last message',
        amount: 'Amount', currency: 'Currency', type: 'Type', kind: 'Kind', credits: 'Credits',
        action: 'Action', admin: 'Admin', admin_email: 'Admin', target: 'Target', note: 'Note', reason: 'Reason',
        subject: 'Subject', message: 'Message', count: 'Count', revenue: 'Revenue', purchases: 'Purchases',
        tickets: 'Tickets', category: 'Category', category_label: 'Category', description: 'Description',
        details: 'Details', source: 'Source',
      },
    },
  },
  legal: {
    back: 'Back to home',
    draft: 'Last updated: August 2026',
    pdf: 'Download as PDF',
    pages: {
      privacy: {
        title: 'Privacy Policy',
        sections: [
          { h: '1. Data controller', lines: ['Sandy Smajic, BSc IT', 'Sandy Smajic Consulting', 'Maxstr. 3, 45127 Essen, Germany', 'Phone: +49 176 70035262', 'Email (KRUG app and privacy questions): info@krug-app.eu', 'Email (Consulting): info@sandysmajic.com'] },
          { h: '2. Scope of this policy', p: 'This privacy policy applies to the KRUG mobile app (including the KRUG ISKRA module) and the website krug-app.eu. It explains which personal data we collect, for what purposes, on which legal basis, how long we retain it and which rights you have under the General Data Protection Regulation (GDPR).' },
          { h: '3. Account and registration data', p: 'When you register, we process the data required to create and manage your account: display name, email address, password (stored only as a secure hash), registration date and account verification status. The legal basis is the performance of a contract (Art. 6(1)(b) GDPR).' },
          { h: '4. Profile information', p: 'Data you enter into your profile (e.g. name, city, country, languages, interests, description) is processed to display your profile and enable the community\u2019s networking features (Art. 6(1)(b) GDPR). Profile data is visible to other users to the extent the app\u2019s features require — only enter what you wish to share.' },
          { h: '5. Photos and uploaded media', p: 'Photos and other media you upload (profile photos, images for posts, events or business profiles) are stored on our servers and displayed in the app according to the purpose of the feature. You can remove media by deleting the respective content or your entire account.' },
          { h: '6. Location data', p: 'If you grant location access in your device settings, we use it to show you people, events and businesses nearby. Location access is voluntary and can be disabled at any time in your device settings; the app will then work without proximity-based features. Legal basis: your consent (Art. 6(1)(a) GDPR).' },
          { h: '7. Messaging and user-generated content', p: 'Messages, comments, posts and other content you create are processed and displayed so that communication and the community function (Art. 6(1)(b) GDPR). We review the content of messages only when violations are reported, for moderation and user safety (Art. 6(1)(f) GDPR — legitimate interest).' },
          { h: '8. Voice Intro and audio recordings', p: 'If you use the Voice Intro feature, the audio recording you create is stored and played as part of your profile until you remove it yourself. The recording is content you voluntarily publish; the legal basis is the performance of a contract and your consent (Art. 6(1)(a) and (b) GDPR).' },
          { h: '9. KRUG ISKRA — profile and preferences', p: 'The KRUG ISKRA module is designed for dating and is available exclusively to adults (18+). Data you enter into your ISKRA profile — including dating preferences — may reveal special categories of personal data (e.g. sexual orientation). We process such data exclusively on the basis of your explicit consent (Art. 9(2)(a) GDPR) and only for the purpose of display and matching within the module. You may withdraw your consent at any time by deleting your ISKRA profile, without detriment to the rest of the app.' },
          { h: '10. Events and community interactions', p: 'When you create events, RSVP, join groups and interact with content, we process this data to display and organize community activities (Art. 6(1)(b) GDPR).' },
          { h: '11. Business listings and profiles', p: 'Data about businesses and listings (name, category, contact, location, description, photos) is published publicly in the app. If you register a business, we additionally process your contact details as the profile owner for verification and management (Art. 6(1)(b) GDPR).' },
          { h: '12. Technical and device data', p: 'For stability, security and troubleshooting we process technical data such as device type, operating system, app version, IP address and error logs (Art. 6(1)(f) GDPR — legitimate interest in a secure and stable service).' },
          { h: '13. Push notification tokens', p: 'If you allow push notifications, we store the technical token of your device so that we can send you notifications (e.g. about new messages or support replies). You can disable notifications at any time in your device settings (Art. 6(1)(a) and (b) GDPR).' },
          { h: '14. Analytics and cookies', p: 'On the website we use our own, anonymized visit statistics, exclusively with your consent via the cookie banner (Art. 6(1)(a) GDPR); you can withdraw consent via the cookie settings in the website footer. We do not use third-party advertising cookies, we do not track you for advertising purposes and we do not sell your data.' },
          { h: '15. In-app purchases and subscriptions', p: 'Purchases of credits, tickets and subscriptions are processed via the app stores. Apple (App Store) and Google (Google Play) process the payment as independent controllers under their own terms and privacy policies; we receive only a purchase confirmation (e.g. type and time), without any details of your payment instrument. Legal basis: performance of a contract (Art. 6(1)(b) GDPR).' },
          { h: '16. Service providers and recipients', p: 'For technical operations we use carefully selected service providers: hosting and backend infrastructure (Emergent platform) and the sending of website emails (Resend). Providers process data exclusively under data processing agreements and on our instructions. We do not sell your data and do not share it with third parties for marketing purposes.' },
          { h: '17. International data transfers', p: 'Should a service provider process data outside the European Union, this takes place only with the safeguards provided for by the GDPR (e.g. standard contractual clauses, Art. 46 GDPR).' },
          { h: '18. Data retention', p: 'We store account data for as long as the account exists. After account deletion we delete or anonymize personal data, unless we are legally obliged to retain it (e.g. tax and commercial retention duties for purchases — up to 10 years under German law). Technical server logs are retained only briefly. Waitlist data is stored until the app launch and a reasonable period thereafter, or until consent is withdrawn.' },
          { h: '19. Account deletion', p: 'You can request deletion of your account at any time via info@krug-app.eu — we delete the account and associated personal data (profile, photos, recordings, messages, ISKRA data) without undue delay, except for data we are legally required to retain.' },
          { h: '20. Your rights', lines: ['Access to the data we hold about you (Art. 15 GDPR)', 'Rectification of inaccurate data (Art. 16 GDPR)', 'Erasure of your data (Art. 17 GDPR)', 'Restriction of processing (Art. 18 GDPR)', 'Data portability (Art. 20 GDPR)', 'Objection to processing (Art. 21 GDPR)', 'Withdrawal of consent at any time, without detriment (Art. 7(3) GDPR)', 'Complaint to the supervisory authority: Landesbeauftragte f\u00fcr Datenschutz und Informationsfreiheit NRW, Germany (Art. 77 GDPR)', 'To exercise your rights, an email to info@krug-app.eu is sufficient'] },
          { h: '21. Data security', p: 'We apply appropriate technical and organizational measures: TLS encryption of transmissions, secure hashing of passwords and access restricted to authorized persons. Please note that no system can guarantee absolute security.' },
          { h: '22. Minors', p: 'The KRUG app is intended for persons over 16 years of age; the KRUG ISKRA module is intended exclusively for adults (18+). We do not knowingly collect data of minors below the permitted age; if we become aware of such an account, we delete it.' },
          { h: '23. Blocking, reporting and moderation', p: 'For the safety of the community we process reports of rule violations, blocks and appeals (including the reported content and data of the users involved), as well as administrative measures such as warnings or account suspensions (Art. 6(1)(f) GDPR — legitimate interest in a safe community).' },
          { h: '24. Changes to this policy', p: 'We may update this privacy policy from time to time, for example when app features change. The current version is always published on this page; we inform users of material changes in the app or by email.' },
          { h: '25. Contact for privacy questions', p: 'For questions, requests and objections regarding data protection, write to us at info@krug-app.eu or by post to the address stated in section 1. We generally respond within 30 days.' },
        ],
      },
      terms: {
        title: 'Terms of Use',
        sections: [
          { h: '1. Scope', p: 'These terms of use apply to the KRUG mobile app (including the KRUG ISKRA module) and the website krug-app.eu. By using the app or website you accept these terms. Community conduct is additionally governed by the Community Guidelines.' },
          { h: '2. Provider', lines: ['Sandy Smajic Consulting', 'Sandy Smajic, BSc IT', 'Maxstr. 3, 45127 Essen, Germany', 'Phone: +49 176 70035262', 'Email (KRUG app): info@krug-app.eu', 'Email (Consulting): info@sandysmajic.com'] },
          { h: '3. Description of the service', p: 'KRUG is a social and community platform for the diaspora: connecting people, discovering businesses and events, groups and communities, mini-games and the KRUG ISKRA dating module. The website presents the app and offers a waitlist signup; joining the waitlist is free and non-binding and does not create a contractual relationship.' },
          { h: '4. Registration and account', p: 'The app is intended for persons over 16 years of age; the KRUG ISKRA module is exclusively for adults (18+). You confirm that your registration data is accurate, you keep your credentials confidential and you do not share your account with third parties. Creating accounts for third parties without their consent and false identities are prohibited.' },
          { h: '5. User content', p: 'You retain all rights to the content you publish (text, photos, audio, events, listings). By publishing you grant us a non-exclusive, royalty-free, worldwide license to display and technically process that content within the app — until you remove the content or delete your account. You are responsible for ensuring your content does not violate laws or the rights of third parties; prohibited content is listed in the Community Guidelines. We reserve the right to remove content that breaches these terms.' },
          { h: '6. Additional rules for KRUG ISKRA', p: 'The ISKRA module is only accessible to adults (18+). Respectful and consensual communication is mandatory; explicit content, pressure, harassment, commercial solicitation, fraud and extortion are prohibited. Violations lead to removal of content, suspension or permanent deletion of the account.' },
          { h: '7. Third-party events and businesses', p: 'Events, business profiles and listings are created by users and third parties; the respective organizers and owners are responsible for their accuracy, quality and lawfulness. Attending events and business dealings with third parties are at your own risk.' },
          { h: '8. Purchases, credits and subscriptions', p: 'Purchases of credits, tickets and subscriptions are billed via the app stores (Apple App Store and Google Play) and their payment terms apply. Prices and scope are shown before purchase. Credits are a virtual unit with no cash value: they cannot be exchanged for money, transferred to another account or refunded outside the app stores\u2019 policies. Subscriptions renew automatically until cancelled in your store account settings; cancellation and refunds are handled exclusively via your Apple or Google account. We announce price changes in advance within the app.' },
          { h: '9. Moderation, suspension and termination', p: 'For the safety of the community we may warn, temporarily suspend or permanently remove accounts that breach these terms or the Community Guidelines, and remove content where necessary — with the option to appeal in the app. You may terminate your use at any time by deleting your account; active subscriptions then end according to the rules of the respective store.' },
          { h: '10. Availability and changes to the service', p: 'We strive for constant availability but do not guarantee uninterrupted operation (e.g. maintenance, technical outages). We may develop, modify or discontinue app features; we announce material changes in the app.' },
          { h: '11. Liability', p: 'We are liable without limitation in cases of intent and gross negligence and for injury to life, body or health. In cases of slight negligence we are liable only for breach of essential contractual obligations, limited to foreseeable damage. We are not liable for content of users and third parties. The provisions of the German Product Liability Act and mandatory consumer rights remain unaffected.' },
          { h: '12. Intellectual property', p: 'The KRUG name, logo, design, texts and the program code of the app and website are the property of the provider and may not be reproduced or used without written permission.' },
          { h: '13. Changes to these terms', p: 'We may amend these terms with notice in the app or by email; material changes are announced reasonably in advance. By continuing to use the service after the changes take effect you accept the new version; if you object, you may delete your account.' },
          { h: '14. Applicable law and jurisdiction', p: 'The law of the Federal Republic of Germany applies, excluding conflict-of-law rules; consumers retain the mandatory protective provisions of their country of residence. Place of jurisdiction is Essen, where legally permissible.' },
          { h: '15. Contact', p: 'For questions about these terms write to info@krug-app.eu — we generally respond within 2 business days.' },
        ],
      },
      'community-guidelines': {
        title: 'Community Guidelines',
        sections: [
          { h: 'Purpose of the community', p: 'KRUG brings together people of the diaspora, their businesses, events and communities. These guidelines apply to all app users and protect the safety and quality of the community.' },
          { h: 'Respect and conduct', p: 'We do not tolerate hate speech, discrimination, harassment, threats or insults — regardless of nationality, religion, gender or origin. Communicate the way you would want to be communicated with.' },
          { h: 'Authenticity', p: 'Profiles, businesses and events must be real and accurate. Impersonation, fraud, spam and unauthorized advertising lead to removal of content or accounts.' },
          { h: 'Additional rules for KRUG ISKRA', p: 'The ISKRA module is intended exclusively for adults (18+). Respectful communication and respecting other users\u2019 boundaries are mandatory; explicit content and pressure are prohibited.' },
          { h: 'Prohibited content', p: 'Prohibited are illegal content, violence, explicit material, data of third parties without their consent, and content that infringes intellectual property rights.' },
          { h: 'Reporting violations', p: 'Report content and users who break the rules directly in the app or via email to info@krug-app.eu. Every report is reviewed confidentially.' },
          { h: 'Measures and consequences', p: 'Depending on the severity of the violation we issue warnings, temporary suspensions or permanent account removal, and notify the competent authorities where necessary.' },
          { h: 'Changes to these guidelines', p: 'We may update these guidelines from time to time; the current version is published on this page.' },
        ],
      },
      contact: {
        title: 'Contact',
        sections: [
          { h: 'Publisher (Imprint)', lines: ['Sandy Smajic Consulting', 'Sandy Smajic, BSc IT', 'Maxstr. 3', '45127 Essen', 'Germany'] },
          { h: 'Contact', lines: ['Phone: +49 176 70035262', 'Email (KRUG app): info@krug-app.eu', 'Email (Consulting): info@sandysmajic.com'] },
          { h: 'Responsible for content (§ 18 Abs. 2 MStV)', lines: ['Sandy Smajic', 'Address as above'] },
          { h: 'Business enquiries', p: 'For partnerships, business profiles, events and media enquiries, email us — we typically reply within 2 business days.' },
        ],
      },
    },
  },
};

export const translations = { bs, de, en };
